;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="2b3797c5-c854-4780-9cea-e279ff8cdd81",e._sentryDebugIdIdentifier="sentry-dbid-2b3797c5-c854-4780-9cea-e279ff8cdd81")}catch(e){}}();
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 13028:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(7452);
// EXTERNAL MODULE: ./assets/common/js/polyfills.js
var polyfills = __webpack_require__(58345);
// EXTERNAL MODULE: ./node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(27813);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/sdk.js + 1 modules
var sdk = __webpack_require__(87447);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4899);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/index.js + 225 modules
var esm = __webpack_require__(43560);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-urls.js
var blacklisted_urls = __webpack_require__(1858);
// EXTERNAL MODULE: ./assets/exception-handling/blacklisted-errors.js
var blacklisted_errors = __webpack_require__(83731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(5338);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var dist = __webpack_require__(47767);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(84976);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 14 modules
var mobxreact_esm = __webpack_require__(44015);
// EXTERNAL MODULE: ./react/public-api/index.tsx
var public_api = __webpack_require__(35750);
// EXTERNAL MODULE: ./react/public-api/utils.ts
var utils = __webpack_require__(86063);
// EXTERNAL MODULE: ./react/stores/hooks.ts
var hooks = __webpack_require__(9432);
// EXTERNAL MODULE: ./react/ui/index.ts + 2 modules
var ui = __webpack_require__(10775);
;// ./react/auth/Invitation.tsx







function Invitation() {
  const {
    invitationId
  } = (0,dist/* useParams */.g)();
  const [errors, setErrors] = (0,react.useState)({});
  const [name, setName] = (0,react.useState)('');
  const [password, setPassword] = (0,react.useState)('');
  const [password2, setPassword2] = (0,react.useState)('');
  const publicApi = (0,public_api/* default */.Ay)();
  const send = async () => {
    setErrors({});
    const data = {
      full_name: name,
      password,
      password2
    };
    try {
      await publicApi.AuthAcceptInvitationApi.create({
        id: invitationId,
        request: data
      });
      window.location.replace('/');
    } catch (error) {
      const response = await (0,utils/* getErrors */.Y)(error);
      setErrors(response);
    }
  };
  const [handleSend, isSending] = (0,hooks/* useAsyncFunction */.m_)(send);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("h2", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Accept invitation')), /*#__PURE__*/react.createElement("p", {
    className: "mt-3 text-center text-sm text-gray-500"
  }, gettext('You were invited to join your team at Retino. Please enter your name and choose your new password. You will use this password, together with your email, to log into Retino.')), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    autoFocus: true,
    name: "fullname",
    value: name,
    label: gettext('Your name'),
    onChange: setName,
    error: errors.full_name
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password1",
    type: "password",
    value: password,
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    onChange: setPassword,
    error: errors.password
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password2",
    type: "password",
    value: password2,
    label: gettext('Password again'),
    onChange: setPassword2,
    error: errors.password2
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    submit: true,
    primary: true,
    fluid: true,
    loading: isSending,
    onClick: handleSend
  }, gettext('Join team')))))));
}
/* harmony default export */ const auth_Invitation = ((0,mobxreact_esm/* observer */.PA)(Invitation));
;// ./react/auth/InvitationExpired.tsx


function InvitationExpired() {
  return /*#__PURE__*/react.createElement("div", {
    className: "my-6"
  }, /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    warning: true
  }, gettext('Your invitation has expired.')));
}
/* harmony default export */ const auth_InvitationExpired = (InvitationExpired);
// EXTERNAL MODULE: ./react/routes/utils.ts
var routes_utils = __webpack_require__(93893);
;// ./react/routes/codegen/appRoutes.ts

const appRoutes = {
  demoKrystofee: (0,routes_utils/* url */.OZ)('/demo-krystofee/'),
  tickets: (0,routes_utils/* url */.OZ)('/tickets/'),
  ticketsDetailTicketDetail: (0,routes_utils/* url */.OZ)('/tickets/detail/:ticketId/'),
  ticketsNew: (0,routes_utils/* url */.OZ)('/tickets/new/'),
  ticketsTicketIdProductsFiles: (0,routes_utils/* url */.OZ)('/tickets/:ticketId/products-files'),
  products: (0,routes_utils/* url */.OZ)('/products/'),
  communication: (0,routes_utils/* url */.OZ)('/communication/'),
  settings: (0,routes_utils/* url */.OZ)('/settings/'),
  settingsUpgrade: (0,routes_utils/* url */.OZ)('/settings/upgrade/'),
  settingsUpgradeWelcome: (0,routes_utils/* url */.OZ)('/settings/upgrade/welcome/'),
  settingsAutomationTriggers: (0,routes_utils/* url */.OZ)('/settings/automation/triggers/'),
  settingsAutomationTriggersDetail: (0,routes_utils/* url */.OZ)('/settings/automation/triggers/:pk/'),
  settingsAutomationTriggersCreate: (0,routes_utils/* url */.OZ)('/settings/automation/triggers/create/'),
  settingsAutomationTriggersInactive: (0,routes_utils/* url */.OZ)('/settings/automation/triggers/inactive/'),
  settingsBadge: (0,routes_utils/* url */.OZ)('/settings/badge/'),
  settingsBillingOverview: (0,routes_utils/* url */.OZ)('/settings/billing/overview/'),
  settingsBillingTransactions: (0,routes_utils/* url */.OZ)('/settings/billing/transactions/'),
  settingsCannedReplies: (0,routes_utils/* url */.OZ)('/settings/canned-replies/'),
  settingsCannedRepliesDetail: (0,routes_utils/* url */.OZ)('/settings/canned-replies/:pk/'),
  settingsCannedRepliesCreate: (0,routes_utils/* url */.OZ)('/settings/canned-replies/create'),
  settingsCompany: (0,routes_utils/* url */.OZ)('/settings/company/'),
  settingsBilling: (0,routes_utils/* url */.OZ)('/settings/billing/'),
  settingsCustomField: (0,routes_utils/* url */.OZ)('/settings/custom-field/'),
  settingsTicketCustomFieldDetail: (0,routes_utils/* url */.OZ)('/settings/ticket-custom-field/:pk/'),
  settingsTicketCustomFieldCreate: (0,routes_utils/* url */.OZ)('/settings/ticket-custom-field/create/'),
  settingsProductCustomFieldDetail: (0,routes_utils/* url */.OZ)('/settings/product-custom-field/:pk/'),
  settingsProductCustomFieldCreate: (0,routes_utils/* url */.OZ)('/settings/product-custom-field/create/'),
  settingsDocuments: (0,routes_utils/* url */.OZ)('/settings/documents/'),
  settingsDocumentsTicketTypeCreate: (0,routes_utils/* url */.OZ)('/settings/documents/:ticketType/create/'),
  settingsDocumentsTicketTypeDetail: (0,routes_utils/* url */.OZ)('/settings/documents/:ticketType/:pk/'),
  settingsEmailing: (0,routes_utils/* url */.OZ)('/settings/emailing/'),
  settingsEmailingDetail: (0,routes_utils/* url */.OZ)('/settings/emailing/:pk/'),
  settingsOrders: (0,routes_utils/* url */.OZ)('/settings/orders/'),
  settingsProcesses: (0,routes_utils/* url */.OZ)('/settings/processes/'),
  settingsRefunds: (0,routes_utils/* url */.OZ)('/settings/refunds/'),
  settingsRefundOptions: (0,routes_utils/* url */.OZ)('/settings/refund-options/'),
  settingsSubscriptionsUnpaidInvoices: (0,routes_utils/* url */.OZ)('/settings/subscriptions/unpaid-invoices/'),
  settingsBillingDisabledVerifyPayment: (0,routes_utils/* url */.OZ)('/settings/billing/disabled-verify-payment/'),
  settingsTags: (0,routes_utils/* url */.OZ)('/settings/tags/'),
  settingsTagsDetail: (0,routes_utils/* url */.OZ)('/settings/tags/:pk'),
  settingsTeam: (0,routes_utils/* url */.OZ)('/settings/team/'),
  settingsTicketTypes: (0,routes_utils/* url */.OZ)('/settings/ticket-types/'),
  settingsTicketTypesDetail: (0,routes_utils/* url */.OZ)('/settings/ticket-types/:pk/'),
  settingsTicketTypesFormPkForm: (0,routes_utils/* url */.OZ)('/settings/ticket-types-form/:pk/form/'),
  settingsTicketViews: (0,routes_utils/* url */.OZ)('/settings/ticket-views/'),
  settingsTicketViewsDetail: (0,routes_utils/* url */.OZ)('/settings/ticket-views/:pk/'),
  settingsTicketViewsCreate: (0,routes_utils/* url */.OZ)('/settings/ticket-views/create/'),
  settingsTransportCustomerPaid: (0,routes_utils/* url */.OZ)('/settings/transport/customer-paid/'),
  settingsTransportShipping: (0,routes_utils/* url */.OZ)('/settings/transport/shipping/'),
  settingsUser: (0,routes_utils/* url */.OZ)('/settings/user/'),
  settingsApiV2: (0,routes_utils/* url */.OZ)('/settings/api-v2/'),
  settingsApiV2Webhooks: (0,routes_utils/* url */.OZ)('/settings/api-v2/webhooks/'),
  settingsApiV2WebhooksDetail: (0,routes_utils/* url */.OZ)('/settings/api-v2/webhooks/:pk/'),
  settingsShippingIntegrations: (0,routes_utils/* url */.OZ)('/settings/shipping/integrations/'),
  settingsShippingContract: (0,routes_utils/* url */.OZ)('/settings/shipping/contract/'),
  settingsShippingContractDetail: (0,routes_utils/* url */.OZ)('/settings/shipping/contract/:pk/'),
  settingsShippingAddresses: (0,routes_utils/* url */.OZ)('/settings/shipping/addresses/'),
  settingsShippingCustomerPaid: (0,routes_utils/* url */.OZ)('/settings/shipping/customer-paid/'),
  settingsShippingShopPaid: (0,routes_utils/* url */.OZ)('/settings/shipping/shop-paid/'),
  settingsShippingShippingContractsCreate: (0,routes_utils/* url */.OZ)('/settings/shipping/shipping-contracts-create/'),
  settingsShippingShippingContractsDetail: (0,routes_utils/* url */.OZ)('/settings/shipping/shipping-contracts/:pk/'),
  settingsShippingAutomation: (0,routes_utils/* url */.OZ)('/settings/shipping/automation/'),
  settingsMarketplace: (0,routes_utils/* url */.OZ)('/settings/marketplace/'),
  settingsMarketplaceInstalledPluginDetail: (0,routes_utils/* url */.OZ)('/settings/marketplace/installed-plugin/:pk/?ticket_type=:ticketType'),
  settingsPortal: (0,routes_utils/* url */.OZ)('/settings/portal/'),
  settingsPortalIntegration: (0,routes_utils/* url */.OZ)('/settings/portal/integration/'),
  settingsShippingPortal: (0,routes_utils/* url */.OZ)('/settings/shipping/portal/'),
  settingsShippingPortalIntegration: (0,routes_utils/* url */.OZ)('/settings/shipping/portal/integration/'),
  notifications: (0,routes_utils/* url */.OZ)('/notifications/'),
  documentsIframeDocumentPreviewDetail: (0,routes_utils/* url */.OZ)('/documents/iframe/document-preview/:pk/'),
  stats: (0,routes_utils/* url */.OZ)('/stats/'),
  statsRating: (0,routes_utils/* url */.OZ)('/stats/rating/'),
  statsProducts: (0,routes_utils/* url */.OZ)('/stats/products/'),
  statsReturnRate: (0,routes_utils/* url */.OZ)('/stats/return-rate/'),
  onboardingPlatformIntegrationPlatformIntegrationIdConnectAccount: (0,routes_utils/* url */.OZ)('/onboarding/platform-integration/:platformIntegrationId/connect-account/'),
  orders: (0,routes_utils/* url */.OZ)('/orders/'),
  refunds: (0,routes_utils/* url */.OZ)('/refunds/'),
  shipping: (0,routes_utils/* url */.OZ)('/shipping/'),
  shippingPortalShipping: (0,routes_utils/* url */.OZ)('/shipping-portal/shipping'),
  activity: (0,routes_utils/* url */.OZ)('/activity/'),
  index: (0,routes_utils/* url */.OZ)('/'),
  demo: (0,routes_utils/* url */.OZ)('/demo/'),
  search: (0,routes_utils/* url */.OZ)('/search/'),
  tracking: (0,routes_utils/* url */.OZ)('/tracking/'),
  trackingShipping: (0,routes_utils/* url */.OZ)('/tracking/shipping/'),
  trackingIssues: (0,routes_utils/* url */.OZ)('/tracking/issues/'),
  trackingAnalytics: (0,routes_utils/* url */.OZ)('/tracking/analytics/'),
  trackingSettingsProviders: (0,routes_utils/* url */.OZ)('/tracking/settings/providers/'),
  trackingSettingsOrders: (0,routes_utils/* url */.OZ)('/tracking/settings/orders/'),
  trackingSettingsOrdersCopIdStatusMapping: (0,routes_utils/* url */.OZ)('/tracking/settings/orders/:copId/status-mapping/'),
  trackingSettingsTags: (0,routes_utils/* url */.OZ)('/tracking/settings/tags/'),
  trackingSettingsCarrierTransitTimes: (0,routes_utils/* url */.OZ)('/tracking/settings/carrier-transit-times/'),
  trackingSettingsTrackingApi: (0,routes_utils/* url */.OZ)('/tracking/settings/tracking-api/'),
  trackingSettingsTrackntraceIntegrations: (0,routes_utils/* url */.OZ)('/tracking/settings/trackntrace/integrations/'),
  trackingSettingsCostAnalysis: (0,routes_utils/* url */.OZ)('/tracking/settings/cost-analysis/'),
  trackingSettingsWebhooks: (0,routes_utils/* url */.OZ)('/tracking/settings/webhooks/'),
  trackingSettingsAutomation: (0,routes_utils/* url */.OZ)('/tracking/settings/automation/'),
  trackingSettingsEmailing: (0,routes_utils/* url */.OZ)('/tracking/settings/emailing/'),
  trackingSettingsEmailDomains: (0,routes_utils/* url */.OZ)('/tracking/settings/email-domains/'),
  trackingSettingsEmailDomainsDetail: (0,routes_utils/* url */.OZ)('/tracking/settings/email-domains/:pk/'),
  trackingSettingsEmailDomainsPkRefresh: (0,routes_utils/* url */.OZ)('/tracking/settings/email-domains/:pk/refresh/'),
  trackingSettingsNotifications: (0,routes_utils/* url */.OZ)('/tracking/settings/notifications/'),
  settingsBranches: (0,routes_utils/* url */.OZ)('/settings/branches/')
};
/* harmony default export */ const codegen_appRoutes = (appRoutes);
;// ./react/routes/codegen/authRoutes.ts

const authRoutes = {
  companyLaunchpad: (0,routes_utils/* url */.OZ)('/company/launchpad/'),
  companySetActiveAccountCompanyDetail: (0,routes_utils/* url */.OZ)('/:lang/company/set-active-account/:companyId/'),
  companyInvitationAcceptInvitationDetail: (0,routes_utils/* url */.OZ)('/:lang/company/invitation-accept/:invitationId/'),
  companyInvitationExpired: (0,routes_utils/* url */.OZ)('/:lang/company/invitation-expired/'),
  authLogin: (0,routes_utils/* url */.OZ)('/:lang/auth/login/'),
  authLogout: (0,routes_utils/* url */.OZ)('/:lang/auth/logout/'),
  authPasswordReset: (0,routes_utils/* url */.OZ)('/:lang/auth/password_reset/'),
  authResetUidb64Token: (0,routes_utils/* url */.OZ)('/:lang/auth/reset/:uidb64/:token/'),
  onboarding: (0,routes_utils/* url */.OZ)('/:lang/onboarding/'),
  onboardingPlatformIntegrationPlatformIntegrationDetail: (0,routes_utils/* url */.OZ)('/:lang/onboarding/platform-integration/:platformIntegrationId/'),
  onboardingPlatformIntegrationPlatformIntegrationIdCompleted: (0,routes_utils/* url */.OZ)('/:lang/onboarding/platform-integration/:platformIntegrationId/completed/'),
  onboardingShoptetDisplayEmailPlatformIntegrationDetail: (0,routes_utils/* url */.OZ)('/:lang/onboarding/shoptet/display-email/:platformIntegrationId/')
};
/* harmony default export */ const codegen_authRoutes = (authRoutes);
;// ./react/auth/Login.tsx








function Login() {
  const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
  const [errors, setErrors] = (0,react.useState)(null);
  const [email, setEmail] = (0,react.useState)('');
  const [password, setPassword] = (0,react.useState)('');
  const publicApi = (0,public_api/* default */.Ay)();
  const next = new URLSearchParams(window.location.search).get('next');
  const login = async () => {
    setIsSubmitting(true);
    setErrors(null);
    try {
      await publicApi.AuthLoginApi.create({
        request: {
          email,
          password
        }
      });
      if (next) window.location.replace(next);else window.location.href = codegen_appRoutes.index();
    } catch (error) {
      console.error(error);
      if ((0,utils/* isResponse */.S)(error)) {
        setErrors(await (0,utils/* getErrors */.Y)(error));
      }
      setIsSubmitting(false);
    }
  };
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: login
  }, /*#__PURE__*/react.createElement("h2", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Sign in to your account')), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    autoFocus: true,
    autoComplete: true,
    name: "email",
    type: "email",
    label: gettext('Email'),
    tabIndex: 1,
    error: errors === null || errors === void 0 ? void 0 : errors.email,
    value: email,
    onChange: setEmail
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    tabIndex: 2,
    autoComplete: true,
    label: gettext('Password'),
    name: "password",
    type: "password",
    error: (errors === null || errors === void 0 ? void 0 : errors.password) || (errors === null || errors === void 0 ? void 0 : errors.error),
    value: password,
    onChange: setPassword
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    fluid: true,
    submit: true,
    tabIndex: 3,
    loading: isSubmitting
  }, gettext('Sign in'))), /*#__PURE__*/react.createElement("div", {
    className: "space-y-2 text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement("div", null, gettext('Forgotten password'), "?", ' ', /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: codegen_authRoutes.authPasswordReset({
      lang: window.appState.lang
    }),
    className: "underline",
    style: {
      fontWeight: 'normal'
    }
  }, gettext('Reset here'))), /*#__PURE__*/react.createElement("div", null, gettext("Don't have an account?"), ' ', /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: codegen_authRoutes.onboarding({
      lang: window.appState.lang
    }) + (next ? "?next=".concat(next) : ''),
    className: "underline",
    style: {
      fontWeight: 'normal'
    }
  }, gettext('Sign up'))))))));
}
/* harmony default export */ const auth_Login = ((0,mobxreact_esm/* observer */.PA)(Login));
;// ./react/auth/PasswordReset.tsx






function PasswordReset() {
  const [email, setEmail] = (0,react.useState)('');
  const [errors, setErrors] = (0,react.useState)({});
  const [isSuccessful, setIsSuccessful] = (0,react.useState)(false);
  const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
  const publicApi = (0,public_api/* default */.Ay)();
  const send = async () => {
    setIsSubmitting(true);
    try {
      await publicApi.AuthPasswordResetApi.create({
        request: {
          email
        }
      });
      setErrors({});
      setIsSuccessful(true);
    } catch (error) {
      const response = await (0,utils/* getErrors */.Y)(error);
      setErrors(response);
      setIsSuccessful(false);
    }
    setIsSubmitting(false);
  };
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: send
  }, /*#__PURE__*/react.createElement("h2", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Forgotten password')), /*#__PURE__*/react.createElement("p", {
    className: "mt-3 text-center text-sm text-gray-500"
  }, gettext("Enter the email associated with your account and we'll give you instructions on how to set up your new password.")), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, isSuccessful ? /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    success: true
  }, gettext('Please check your email. We have sent you an email with instructions.')) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    autoFocus: true,
    required: true,
    name: "email",
    label: gettext('Email'),
    value: email,
    error: errors === null || errors === void 0 ? void 0 : errors.email,
    onChange: setEmail
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    fluid: true,
    submit: true,
    loading: isSubmitting,
    disabled: isSuccessful
  }, gettext('Send email')))), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: codegen_authRoutes.authLogin({
      lang: window.appState.lang
    }),
    className: "underline",
    style: {
      fontWeight: 'normal'
    }
  }, gettext('Return to sign-in')))))));
}
/* harmony default export */ const auth_PasswordReset = (PasswordReset);
;// ./react/auth/PasswordSet.tsx






function PasswordSet() {
  const {
    uidb64: uid,
    token
  } = (0,dist/* useParams */.g)();
  const [password1, setPassword1] = (0,react.useState)('');
  const [password2, setPassword2] = (0,react.useState)('');
  const [errors, setErrors] = (0,react.useState)({});
  const [isSuccessful, setIsSuccessful] = (0,react.useState)(false);
  const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
  const publicApi = (0,public_api/* default */.Ay)();
  const send = async () => {
    setIsSubmitting(true);
    try {
      await publicApi.AuthPasswordSetApi.create({
        request: {
          new_password1: password1,
          new_password2: password2,
          uid,
          token: token !== null && token !== void 0 ? token : ''
        }
      });
      setErrors({});
      setIsSuccessful(true);
    } catch (error) {
      const response = await error.response.json();
      setErrors(response);
      setIsSuccessful(false);
    }
    setIsSubmitting(false);
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("h2", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Forgotten password')), /*#__PURE__*/react.createElement("p", {
    className: "mt-3 text-center text-sm text-gray-500"
  }, gettext('Please write your password twice below')), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, isSuccessful ? /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    success: true
  }, gettext('Password has been set.')) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    autoFocus: true,
    required: true,
    type: "password",
    label: gettext('Password'),
    value: password1,
    error: errors === null || errors === void 0 ? void 0 : errors.new_password1,
    onChange: setPassword1
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    type: "password",
    label: gettext('Password again'),
    value: password2,
    error: errors === null || errors === void 0 ? void 0 : errors.new_password2,
    onChange: setPassword2
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    fluid: true,
    loading: isSubmitting,
    disabled: isSuccessful,
    onClick: () => send()
  }, gettext('Set password')))), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: codegen_authRoutes.authLogin({
      lang: window.appState.lang
    }),
    className: "underline ",
    style: {
      fontWeight: 'normal'
    }
  }, gettext('Return to sign-in')))))));
}
/* harmony default export */ const auth_PasswordSet = (PasswordSet);
// EXTERNAL MODULE: ./react/components/errorBoundaries/index.tsx
var errorBoundaries = __webpack_require__(83819);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var helpers_utils = __webpack_require__(41906);
;// ./react/api/codegen/base.ts
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-await-in-loop */
/* eslint-disable no-empty-function */
/* eslint-disable no-useless-constructor */

function querystring(params) {
  let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(params)
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .map(key => querystringSingleKey(key, params[key], prefix)).filter(part => part.length > 0).join('&');
}
function querystringSingleKey(key, value) {
  let keyPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const fullKey = keyPrefix + (keyPrefix.length ? "[".concat(key, "]") : key);
  if (value instanceof Array) {
    const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue))).join("&".concat(encodeURIComponent(fullKey), "="));
    return "".concat(encodeURIComponent(fullKey), "=").concat(multiValue);
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(value.toISOString()));
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(String(value)));
}
class JSONApiResponse {
  constructor(raw) {
    let transformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jsonValue => jsonValue;
    this.raw = raw;
    this.transformer = transformer;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class BaseApi {
  constructor(client) {
    this.client = client;
  }
  async request(path, method, pathParameters, query, body) {
    path = Object.entries(pathParameters).reduce((acc, _ref) => {
      let [paramName, paramValue] = _ref;
      return acc.replace("{".concat(paramName, "}"), String(paramValue));
    }, path);
    return this.client.request({
      path,
      method,
      query,
      body,
      headers: {}
    });
  }
}
function isBlob(value) {
  return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== 'undefined' && value instanceof FormData;
}
function removeEmpty(obj) {
  if (typeof obj === 'object') {
    Object.keys(obj).forEach(key => obj[key] === undefined ? delete obj[key] : {});
  }
  return obj;
}
class FetchError extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
    this.name = 'FetchError';
  }
}
class ResponseError extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
    this.name = 'ResponseError';
  }
}
class BaseApiClient {
  constructor(options) {
    this.options = options;
  }
  async createFetchParams(context) {
    let url = this.options.baseUrl + context.path;
    if (context.query !== undefined && Object.keys(context.query).length > 0) {
      url += "?".concat(querystring(removeEmpty(context.query)));
    }
    const headers = _objectSpread(_objectSpread({}, this.options.getHeaders()), context.headers);
    Object.keys(headers).forEach(key => headers[key] === undefined ? delete headers[key] : {});
    const initParams = {
      method: context.method,
      headers,
      body: context.body
    };
    const init = _objectSpread(_objectSpread({}, initParams), {}, {
      body: isFormData(context.body) || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(removeEmpty(context.body))
    });
    return {
      url,
      init
    };
  }
  async request(context) {
    let fetchParams = await this.createFetchParams(context);
    for (let i = 0; i < this.options.middlewares.length; i += 1) {
      const middleware = this.options.middlewares[i];
      if (middleware.pre) {
        fetchParams = (await middleware.pre(fetchParams)) || fetchParams;
      }
    }
    let response;
    try {
      response = await fetch(fetchParams.url, fetchParams.init);
    } catch (error) {
      for (let i = 0; i < this.options.middlewares.length; i += 1) {
        const middleware = this.options.middlewares[i];
        if (middleware.onError) {
          response = (await middleware.onError({
            error,
            url: fetchParams.url,
            init: fetchParams.init,
            response: response ? response.clone() : undefined
          })) || response;
        }
      }
      if (response === undefined) {
        if (error instanceof Error) {
          throw new FetchError(error, 'The request failed and the interceptors did not return an alternative response');
        } else {
          throw error;
        }
      }
    }
    for (let i = 0; i < this.options.middlewares.length; i += 1) {
      const middleware = this.options.middlewares[i];
      if (middleware.post) {
        response = (await middleware.post({
          url: fetchParams.url,
          init: fetchParams.init,
          response: response.clone()
        })) || response;
      }
    }
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    throw new ResponseError(response, 'Response returned an error code');
  }
}
;// ./react/api/codegen/api.ts

class ActivitiesApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/activities', 'GET', {}, {
      deadline_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.deadline_after,
      deadline_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.deadline_before,
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      owner: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.owner,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      status: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.status
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/activities', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/activities', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/activities/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/activities/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/activities/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/activities/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/activities/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class AddFlagApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/add-flag', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class AiChatCompletionApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/ai/chat-completion', 'GET', {}, {
      hint: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.hint,
      ticket_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_id
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2TokenApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/api/v2/token', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/api/v2/token', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/api/v2/token', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/api/v2/token', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2TokenRollApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/api/v2/token/roll', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2WebhookEndpointsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/api/v2/webhook-endpoints', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2WebhookEndpointsRollSecretApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}/roll-secret', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2WebhookEndpointsTestApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{id}/test', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2WebhookEndpointsRequestsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{webhook_endpoint_pk}/requests', 'GET', {
      webhook_endpoint_pk: requestParameters.webhook_endpoint_pk
    }, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{webhook_endpoint_pk}/requests/{id}', 'GET', {
      id: requestParameters.id,
      webhook_endpoint_pk: requestParameters.webhook_endpoint_pk
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiV2WebhookEndpointsWebhooksRetryApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/api/v2/webhook-endpoints/{webhook_endpoint_pk}/webhooks/{id}/retry', 'POST', {
      id: requestParameters.id,
      webhook_endpoint_pk: requestParameters.webhook_endpoint_pk
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class AuthApiTokenRegenerateApi extends BaseApi {
  async create() {
    const response = await this.request('/auth/api-token/regenerate', 'POST', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class AuthUserApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/auth/user', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/auth/user', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/auth/user', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/auth/user', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/auth/user', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class AuthUserPasswordApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/auth/user/password', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/auth/user/password', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/auth/user/password', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/auth/user/password', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/auth/user/password', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BadgeBadgeSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/badge/badge-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/badge/badge-settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/badge/badge-settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/badge/badge-settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/badge/badge-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingInformationApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/billing-information', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/billing-information', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/billing-information', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/billing-information', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/billing-information', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingBilledInvoicesUnpaidApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/billing/billed-invoices/unpaid', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingBilledInvoicesUnpaidPayApi extends BaseApi {
  async create() {
    const response = await this.request('/billing/billed-invoices/unpaid/pay', 'POST', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingInvoicesApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/billing/invoices', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingPaymentCardsApi extends BaseApi {
  async list() {
    const response = await this.request('/billing/payment-cards', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/billing/payment-cards/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class BillingPaymentCardsSetDefaultApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/billing/payment-cards/{id}/set-default', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class BillingSubscriptionBillingInformationApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/billing/subscription/billing-information', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/billing/subscription/billing-information', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/billing/subscription/billing-information', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/billing/subscription/billing-information', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/billing/subscription/billing-information', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class BillingTransactionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/billing/transactions', 'GET', {}, {
      payment_state: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.payment_state
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/billing/transactions/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CannedRepliesApi extends BaseApi {
  async list() {
    const response = await this.request('/canned-replies', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/canned-replies', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/canned-replies', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/canned-replies/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/canned-replies/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/canned-replies/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/canned-replies/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/canned-replies/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CommonStoreApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/common-store', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CommunicationApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/communication', 'GET', {}, {
      created_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_after,
      created_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_before,
      is_replied: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_replied,
      is_unread: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_unread,
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      ticket_language: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_language,
      ticket_owner: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_owner,
      ticket_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CompanyApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/company', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CompanyInvitationsApi extends BaseApi {
  async list() {
    const response = await this.request('/company-invitations', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/company-invitations', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/company-invitations', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/company-invitations/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/company-invitations/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/company-invitations/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/company-invitations/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/company-invitations/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CompanyLogoApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/company-logo', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/company-logo', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/company-logo', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/company-logo', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CompanySettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/company-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/company-settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/company-settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/company-settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/company-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CompanyCreateCompanyApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/company/create-company', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class CountriesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/countries', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/countries', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/countries', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/countries', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/countries', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CreditNotesCreditNoteApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/credit-notes/credit-note', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/credit-notes/credit-note', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/credit-notes/credit-note', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/credit-notes/credit-note/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/credit-notes/credit-note/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/credit-notes/credit-note/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/credit-notes/credit-note/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/credit-notes/credit-note/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CreditNotesCreditNoteClientsApi extends BaseApi {
  async list() {
    const response = await this.request('/credit-notes/credit-note-clients', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/credit-notes/credit-note-clients/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/credit-notes/credit-note-clients/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/credit-notes/credit-note-clients/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CreditNotesShoptetCreditNoteCancelItemsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/credit-notes/shoptet/credit-note/cancel-items/{id}/', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class CreditNotesShoptetCreditNoteRestockApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/credit-notes/shoptet/credit-note/restock/{id}/', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class CreditNotesShoptetInvoiceApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/credit-notes/shoptet/invoice/{order_id}/', 'GET', {
      order_id: requestParameters.order_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CurrenciesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/currencies', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/currencies', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/currencies', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/currencies', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/currencies', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class CustomFieldsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/custom-fields', 'GET', {}, {
      type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/custom-fields', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/custom-fields', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/custom-fields/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/custom-fields/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/custom-fields/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/custom-fields/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/custom-fields/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardDeadlinesApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/dashboard/deadlines', 'GET', {}, {
      limit: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.limit
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardLastMessagesApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/dashboard/last-messages', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardLastRatingCommentsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/dashboard/last-rating-comments', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/dashboard/settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/dashboard/settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/dashboard/settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/dashboard/settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/dashboard/settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardStatsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/dashboard/stats', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DashboardUserSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/dashboard/user-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/dashboard/user-settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/dashboard/user-settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/dashboard/user-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DhlFreightAccountApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/dhl-freight-account', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DhlLocationsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/dhl-locations', 'GET', {}, {
      api_key: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.api_key,
      password: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.password,
      user: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.user
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DisableAccountApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/disable-account', 'GET', {}, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/disable-account', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class DocumentCreateApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/document-create/{id}/{ticket_id}', 'GET', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/document-create/{id}/{ticket_id}', 'POST', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/document-create/{id}/{ticket_id}', 'OPTIONS', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class DocumentTypesApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/document-types', 'GET', {}, {
      ticket_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/document-types', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/document-types', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/document-types/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/document-types/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/document-types/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/document-types/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/document-types/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class EmailSettingApi extends BaseApi {
  async list() {
    const response = await this.request('/email-setting', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/email-setting', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/email-setting', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/email-setting/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/email-setting/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/email-setting/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/email-setting/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/email-setting/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class LanguagesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/languages', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/languages', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/languages', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/languages', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/languages', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class LaunchpadApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/launchpad', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class MarketplaceInstalledPluginApi extends BaseApi {
  async list() {
    const response = await this.request('/marketplace/installed-plugin', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async options(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class MarketplaceInstalledPluginClientSetupApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/client-setup', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/client-setup', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/client-setup', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/client-setup', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/client-setup', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class MarketplaceInstalledPluginUninstallApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/marketplace/installed-plugin/{id}/uninstall', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class MarketplacePluginApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/marketplace/plugin', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class MarketplacePluginInstallApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/marketplace/plugin/{id}/install', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/marketplace/plugin/{id}/install', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class MarketplaceRemarketingSettingsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/marketplace/remarketing-settings', 'GET', {}, {
      installed_plugin: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.installed_plugin
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/marketplace/remarketing-settings/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/marketplace/remarketing-settings/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/marketplace/remarketing-settings/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class MarketplaceSupplierApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/marketplace/supplier', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/marketplace/supplier', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/marketplace/supplier', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/marketplace/supplier/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/marketplace/supplier/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/marketplace/supplier/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/marketplace/supplier/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/marketplace/supplier/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class NotificationsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/notifications', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class NotificationsLatestNotificationIdApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/notifications/latest-notification-id', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class NotificationsMarkAllAsReadApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/notifications/mark-all-as-read', 'GET', {}, undefined, undefined);
  }
  async create() {
    const response = await this.request('/notifications/mark-all-as-read', 'POST', {}, undefined, undefined);
  }
}
class NotificationsMarkAsReadApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/notifications/mark-as-read/{notification_id}', 'GET', {
      notification_id: requestParameters.notification_id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/notifications/mark-as-read/{notification_id}', 'POST', {
      notification_id: requestParameters.notification_id
    }, undefined, undefined);
  }
}
class NotificationsMarkAsUnreadApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/notifications/mark-as-unread/{notification_id}', 'GET', {
      notification_id: requestParameters.notification_id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/notifications/mark-as-unread/{notification_id}', 'POST', {
      notification_id: requestParameters.notification_id
    }, undefined, undefined);
  }
}
class NotificationsNotificationSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/notifications/notification-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/notifications/notification-settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/notifications/notification-settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/notifications/notification-settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/notifications/notification-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OnboardingCompanyOnboardingStepApi extends BaseApi {
  async list() {
    const response = await this.request('/onboarding/company-onboarding-step', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/onboarding/company-onboarding-step/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/onboarding/company-onboarding-step/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/onboarding/company-onboarding-step/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/onboarding/company-onboarding-step/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OnboardingPlatformIntegrationConnectAccountApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/onboarding/platform-integration/{id}/connect-account', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/onboarding/platform-integration/{id}/connect-account', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
  async options(requestParameters) {
    const response = await this.request('/onboarding/platform-integration/{id}/connect-account', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OrderProviderTypesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/order-provider-types', 'GET', {}, undefined, undefined);
  }
}
class OrderProvidersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/order-providers', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OrdersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/orders', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/orders/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OrdersDataRetentionApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/orders/data-retention', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/orders/data-retention', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/orders/data-retention', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/orders/data-retention', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/orders/data-retention', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class OrdersSampleApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/orders/sample', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class PortalMigrationGuidePortalIntegratedApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/portal-migration-guide/portal-integrated', 'GET', {}, undefined, undefined);
  }
  async create() {
    const response = await this.request('/portal-migration-guide/portal-integrated', 'POST', {}, undefined, undefined);
  }
}
class PortalFormApi extends BaseApi {
  async list() {
    const response = await this.request('/portal/form/', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/portal/form/', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/portal/form/', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form/{id}/', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/portal/form/{id}/', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form/{id}/', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/portal/form/{id}/', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/portal/form/{id}/', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class PortalFormDesignApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/portal/form-design', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/portal/form-design', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form-design', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/portal/form-design', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class PortalFormSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/portal/form-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put() {
    const response = await this.request('/portal/form-settings', 'PUT', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async patch() {
    const response = await this.request('/portal/form-settings', 'PATCH', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/portal/form-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class PortalFormBlockApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/', 'GET', {
      form_pk: requestParameters.form_pk
    }, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/', 'POST', {
      form_pk: requestParameters.form_pk
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/', 'OPTIONS', {
      form_pk: requestParameters.form_pk
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/{id}/', 'GET', {
      form_pk: requestParameters.form_pk,
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/{id}/', 'PUT', {
      form_pk: requestParameters.form_pk,
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/{id}/', 'PATCH', {
      form_pk: requestParameters.form_pk,
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/{id}/', 'DELETE', {
      form_pk: requestParameters.form_pk,
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/block/{id}/', 'OPTIONS', {
      form_pk: requestParameters.form_pk,
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class PortalFormFormStringsApi extends BaseApi {
  async put(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/form-strings', 'PUT', {
      form_pk: requestParameters.form_pk
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/form-strings', 'PATCH', {
      form_pk: requestParameters.form_pk
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/portal/form/{form_pk}/form-strings', 'OPTIONS', {
      form_pk: requestParameters.form_pk
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ProcessStepsApi extends BaseApi {
  async list() {
    const response = await this.request('/process-steps', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/process-steps', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/process-steps', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/process-steps/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/process-steps/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/process-steps/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/process-steps/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/process-steps/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ProductCustomFieldsApi extends BaseApi {
  async list() {
    const response = await this.request('/product-custom-fields', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/product-custom-fields', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/product-custom-fields', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/product-custom-fields/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/product-custom-fields/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/product-custom-fields/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/product-custom-fields/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/product-custom-fields/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ProductsProductsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/products/products', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class QrCodeRefundApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/qr-code-refund', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class RefundAccountsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/refund-accounts', 'GET', {}, {
      currency: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.currency
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/refund-accounts', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/refund-accounts', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/refund-accounts/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/refund-accounts/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/refund-accounts/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/refund-accounts/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/refund-accounts/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RefundBatchApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/refund-batch', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/refund-batch', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/refund-batch', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/refund-batch/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RefundBatchRevertApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/refund-batch/{id}/revert', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RefundOptionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/refund-options', 'GET', {}, {
      ticket_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/refund-options', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/refund-options', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/refund-options/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/refund-options/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/refund-options/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/refund-options/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/refund-options/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RefundRequestApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/refund-request', 'GET', {}, {
      refund_account: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.refund_account,
      ticket: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket,
      waiting: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.waiting
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/refund-request', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/refund-request', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/refund-request/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/refund-request/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class RefundSettingApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/refund-setting', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/refund-setting', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/refund-setting', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/refund-setting', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RetinoShippingProfileApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/retino-shipping/profile', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/retino-shipping/profile', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/retino-shipping/profile', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/retino-shipping/profile', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RetinoShippingShippingBulkActionApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/retino-shipping/shipping/bulk-action', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
  }
}
class RetinoShippingShippingCreateApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/retino-shipping/shipping/create', 'GET', {}, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/retino-shipping/shipping/create', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class RetinoShippingShippingListApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/retino-shipping/shipping/list', 'GET', {}, {
      created_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_after,
      created_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_before,
      ordered_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordered_at_after,
      ordered_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordered_at_before,
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      shipping_provider: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_provider,
      shipping_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_type,
      status: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.status,
      ticket: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class RolesApi extends BaseApi {
  async list() {
    const response = await this.request('/roles', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SearchApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/search/', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.size,
      term: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.term,
      type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SearchModalUsageLogApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/search/modal-usage-log', 'GET', {}, {
      duration_ms: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.duration_ms,
      selected_result_index: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.selected_result_index,
      selected_result_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.selected_result_type,
      selected_result_type_index: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.selected_result_type_index,
      show_all_selected: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.show_all_selected,
      show_more_selected: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.show_more_selected,
      term: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.term
    }, undefined);
  }
}
class ShippingApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      status: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.status
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class ShippingAddressApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping-address', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping-address', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-address', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping-address/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-address/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-address/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping-address/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping-address/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingAddressSetForCpsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping-address/{id}/set-for-cps', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ShippingContractsApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping-contracts', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping-contracts', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-contracts', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping-contracts/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-contracts/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-contracts/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping-contracts/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping-contracts/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingPortalShippingFormProfileApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/shipping-portal/shipping-form-profile', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-portal/shipping-form-profile', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-portal/shipping-form-profile', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-portal/shipping-form-profile', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingProvidersApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping-providers', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingRequestsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping-requests', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping-requests', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-requests', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping-requests/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-requests/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-requests/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping-requests/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping-requests/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingRequestsCreateTransportApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping-requests/{id}/create-transport', 'POST', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ShippingSettingsApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/shipping-settings', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping-settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-settings', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-settings', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-settings', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingTypesApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping-types', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping-types', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping-types', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping-types/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping-types/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping-types/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping-types/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping-types/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingTypesCreateTransportApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping-types/{id}/create-transport/{ticket_id}', 'POST', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ShippingAdditionalContractSettingsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping/additional-contract-settings', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ShippingAddressesNewApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping/addresses-new', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping/addresses-new', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/addresses-new', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/addresses-new/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/addresses-new/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/addresses-new/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping/addresses-new/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping/addresses-new/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingContractsNewApi extends BaseApi {
  async list() {
    const response = await this.request('/shipping/contracts-new', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping/contracts-new', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/contracts-new', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/contracts-new/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/contracts-new/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/contracts-new/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping/contracts-new/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping/contracts-new/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingContractsSettingsApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/contracts/settings/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/contracts/settings/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/contracts/settings/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/shipping/contracts/settings/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingCpsRoutesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/shipping/cps-routes', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/cps-routes', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/cps-routes', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/cps-routes', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingOptionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping/options', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping/options', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/options', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/options/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/options/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/options/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping/options/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping/options/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingRoutesApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping/routes', 'GET', {}, {
      is_retino_cps: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_retino_cps,
      is_shop_paid: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_shop_paid
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/shipping/routes', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/routes', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/routes/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/routes/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/routes/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/shipping/routes/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/shipping/routes/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShippingProfileApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/shipping/shipping-profile', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/shipping/shipping-profile', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/shipping/shipping-profile', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/shipping/shipping-profile', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShippingCancelApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping/shipping/{id}/cancel', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class ShippingShippingConfirmApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping/shipping/{id}/confirm', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class ShippingShippingDeclineApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping/shipping/{id}/decline', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class ShippingShippingListApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping/shipping/list', 'GET', {}, {
      created_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_after,
      created_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_before,
      ordered_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordered_at_after,
      ordered_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordered_at_before,
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      shipping_provider: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_provider,
      shipping_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_type,
      status: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.status
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShopPaidRoutePriceApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/shipping/shop-paid-route-price', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      provider: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.provider
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShopPaidShippingProfileApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/shipping/shop-paid-shipping-profile', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShopPaidShippingProfileActivateApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/shipping/shop-paid-shipping-profile/activate', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShopPaidShippingProfileDeactivateApi extends BaseApi {
  async create() {
    const response = await this.request('/shipping/shop-paid-shipping-profile/deactivate', 'POST', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ShippingShopPaidShippingProfileUsage_reportApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/shipping/shop-paid-shipping-profile/usage_report', 'GET', {}, {
      period: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.period
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StatesApi extends BaseApi {
  async list() {
    const response = await this.request('/states', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/states', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/states', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/states/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/states/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/states/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/states/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/states/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StatsAllUsersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/stats/all-users', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StatsAvgTimeToCloseApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/stats/avg-time-to-close', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/stats/avg-time-to-close', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsOpenClosedApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/open-closed', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsOverallProductCustomFieldsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/overall-product-custom-fields', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsProductCustomFieldsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/product-custom-fields', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsRatingCommentsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/rating-comments', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsRetinoqualityApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/retinoquality', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsReturnRateApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/return-rate', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsReturnedProductsApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/returned-products', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsScoreboardApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/scoreboard', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StatsTotalOpenApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/stats/total-open', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class StripeInvoicePayApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/stripe/invoice/{id}/pay', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/stripe/invoice/{id}/pay', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class StripePaymentMethodApi extends BaseApi {
  async list() {
    const response = await this.request('/stripe/payment-method', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StripePaymentMethodAttachApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/stripe/payment-method/{id}/attach', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/stripe/payment-method/{id}/attach', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StripePaymentMethodDefaultApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/stripe/payment-method/default', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class StripeSetupIntentApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/stripe/setup-intent', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create() {
    const response = await this.request('/stripe/setup-intent', 'POST', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsApplyPromoCodeApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/subscriptions/apply-promo-code', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsPriceApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/subscriptions/price', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/subscriptions/price/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsProductApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/subscriptions/product', 'GET', {}, {
      is_independent: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_independent
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/subscriptions/product/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsPromotionCodeApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/subscriptions/promotion-code/{code}', 'GET', {
      code: requestParameters.code
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsSubscriptionApi extends BaseApi {
  async list() {
    const response = await this.request('/subscriptions/subscription', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/subscriptions/subscription', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/subscriptions/subscription', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/subscriptions/subscription/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/subscriptions/subscription/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/subscriptions/subscription/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/subscriptions/subscription/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsSubscriptionsStateApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/subscriptions/subscriptions-state', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/subscriptions/subscriptions-state', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/subscriptions/subscriptions-state', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/subscriptions/subscriptions-state', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/subscriptions/subscriptions-state', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class SubscriptionsSubscriptionsStateUpcomingPaymentApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/subscriptions/subscriptions-state/upcoming-payment', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TagsApi extends BaseApi {
  async list() {
    const response = await this.request('/tags', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/tags', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/tags', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/tags/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/tags/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/tags/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tags/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/tags/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketCodeSeriesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/ticket-code-series', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/ticket-code-series', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/ticket-code-series', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/ticket-code-series', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketDetailSectionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/ticket-detail-sections', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/ticket-detail-sections/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/ticket-detail-sections/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TicketProductsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/ticket-products', 'GET', {}, {
      is_ticket_closed: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_ticket_closed,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      ticket_state: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_state,
      ticket_type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/ticket-products/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketRefundOptionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/ticket-refund-options', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/ticket-refund-options', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/ticket-refund-options', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/ticket-refund-options/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/ticket-refund-options/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/ticket-refund-options/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/ticket-refund-options/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/ticket-refund-options/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketTypesApi extends BaseApi {
  async list() {
    const response = await this.request('/ticket-types', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/ticket-types', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/ticket-types', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/ticket-types/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/ticket-types/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/ticket-types/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/ticket-types/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/ticket-types/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketViewsApi extends BaseApi {
  async list() {
    const response = await this.request('/ticket-views', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/ticket-views', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/ticket-views', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/ticket-views/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/ticket-views/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/ticket-views/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/ticket-views/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/ticket-views/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets', 'GET', {}, {
      closed_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.closed_at_after,
      closed_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.closed_at_before,
      country: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.country,
      created_at_after: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_after,
      created_at_before: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.created_at_before,
      language: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.language,
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      owner: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.owner,
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size,
      search: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.search,
      shipping_status: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.shipping_status,
      state: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.state,
      tags: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.tags,
      ticket_view: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket_view,
      type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/tickets', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/tickets', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{id}', 'GET', {
      id: requestParameters.id
    }, {
      preview: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.preview
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/tickets/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/tickets/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tickets/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/tickets/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsBulkActionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets-bulk-actions', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsCloseApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/{id}/close', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class TicketsCustomerHistoryApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{id}/customer-history', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async None(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/customer-history', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsGeneratePdfApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{id}/generate-pdf', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsReopenApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/{id}/reopen', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class TicketsDocumentsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/documents', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/documents/{id}', 'DELETE', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
}
class TicketsHistoryApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/history', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, {
      type: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.type
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/history/{id}', 'GET', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsInternalNotesApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/internal-notes', 'POST', {
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/internal-notes/{id}', 'DELETE', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
}
class TicketsMessagesApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/messages', 'POST', {
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/messages/{id}', 'PUT', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/messages/{id}', 'PATCH', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TicketsProductsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products', 'POST', {
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products', 'OPTIONS', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products/{id}', 'GET', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products/{id}', 'PUT', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products/{id}', 'PATCH', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products/{id}', 'DELETE', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/products/{id}', 'OPTIONS', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsRatingApi extends BaseApi {
  async put(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/rating/{id}', 'PUT', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/rating/{id}', 'PATCH', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TicketsSmsMessagesApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/sms-messages', 'POST', {
      ticket_id: requestParameters.ticket_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TicketsTransportApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/transport', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/transport/{id}', 'GET', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/transport/{id}', 'DELETE', {
      id: requestParameters.id,
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
}
class TicketsTriggerLogsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/trigger-logs', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TicketsVerifyApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/verify', 'GET', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/tickets/{ticket_id}/verify', 'POST', {
      ticket_id: requestParameters.ticket_id
    }, undefined, undefined);
  }
}
class TicketsBulkActionApi extends BaseApi {
  async create(requestParameters) {
    const response = await this.request('/tickets/bulk-action', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TicketsHasBeenCreatedRecentlyApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/tickets/has-been-created-recently', 'GET', {}, {
      order_id: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.order_id
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TriggerConditionsTypesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/trigger-conditions/types', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TriggerDelayedActionsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/trigger-delayed-actions', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      ticket: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/trigger-delayed-actions/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class TriggerLogsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/trigger-logs', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering,
      state: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.state,
      ticket: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ticket,
      trigger: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.trigger
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/trigger-logs/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/trigger-logs/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class TriggerLogsRerunApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/trigger-logs/{id}/rerun', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async create(requestParameters) {
    const response = await this.request('/trigger-logs/{id}/rerun', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
  }
}
class TriggersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/triggers', 'GET', {}, {
      is_active: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.is_active
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/triggers', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/triggers', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/triggers/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/triggers/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/triggers/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/triggers/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/triggers/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TriggersTypesApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/triggers/types', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TypesProductCustomFieldsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields', 'GET', {
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields', 'POST', {
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields', 'OPTIONS', {
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields/{id}', 'GET', {
      id: requestParameters.id,
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields/{id}', 'PUT', {
      id: requestParameters.id,
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields/{id}', 'PATCH', {
      id: requestParameters.id,
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields/{id}', 'DELETE', {
      id: requestParameters.id,
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/product-custom-fields/{id}', 'OPTIONS', {
      id: requestParameters.id,
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class TypesStringsApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/types/{ticket_type_id}/strings', 'GET', {
      ticket_type_id: requestParameters.ticket_type_id
    }, undefined, undefined);
  }
}
class UserSignatureApi extends BaseApi {
  async retrieve() {
    const response = await this.request('/user-signature', 'GET', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/user-signature', 'PUT', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/user-signature', 'PATCH', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/user-signature', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class UsersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/users', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class UsersRevokeAccessApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/users/{id}/revoke-access', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/users/{id}/revoke-access', 'POST', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class UsersRoleApi extends BaseApi {
  async retrieve(requestParameters) {
    const response = await this.request('/users/{id}/role', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/users/{id}/role', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
}
class VoucherClientsApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/voucher-clients', 'GET', {}, {
      ordering: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.ordering
    }, undefined);
    return new JSONApiResponse(response).value();
  }
}
class VouchersApi extends BaseApi {
  async list(requestParameters) {
    const response = await this.request('/vouchers', 'GET', {}, {
      page: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page,
      page_size: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.page_size
    }, undefined);
    return new JSONApiResponse(response).value();
  }
  async create(requestParameters) {
    const response = await this.request('/vouchers', 'POST', {}, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async options() {
    const response = await this.request('/vouchers', 'OPTIONS', {}, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async retrieve(requestParameters) {
    const response = await this.request('/vouchers/{id}', 'GET', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
  async put(requestParameters) {
    const response = await this.request('/vouchers/{id}', 'PUT', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async patch(requestParameters) {
    const response = await this.request('/vouchers/{id}', 'PATCH', {
      id: requestParameters.id
    }, undefined, requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.request);
    return new JSONApiResponse(response).value();
  }
  async destroy(requestParameters) {
    const response = await this.request('/vouchers/{id}', 'DELETE', {
      id: requestParameters.id
    }, undefined, undefined);
  }
  async detailOptions(requestParameters) {
    const response = await this.request('/vouchers/{id}', 'OPTIONS', {
      id: requestParameters.id
    }, undefined, undefined);
    return new JSONApiResponse(response).value();
  }
}
class ApiClient extends BaseApiClient {
  constructor(options) {
    super(options);
    this.ActivitiesApi = void 0;
    this.AddFlagApi = void 0;
    this.AiChatCompletionApi = void 0;
    this.ApiV2TokenApi = void 0;
    this.ApiV2TokenRollApi = void 0;
    this.ApiV2WebhookEndpointsApi = void 0;
    this.ApiV2WebhookEndpointsRollSecretApi = void 0;
    this.ApiV2WebhookEndpointsTestApi = void 0;
    this.ApiV2WebhookEndpointsRequestsApi = void 0;
    this.ApiV2WebhookEndpointsWebhooksRetryApi = void 0;
    this.AuthApiTokenRegenerateApi = void 0;
    this.AuthUserApi = void 0;
    this.AuthUserPasswordApi = void 0;
    this.BadgeBadgeSettingsApi = void 0;
    this.BillingInformationApi = void 0;
    this.BillingBilledInvoicesUnpaidApi = void 0;
    this.BillingBilledInvoicesUnpaidPayApi = void 0;
    this.BillingInvoicesApi = void 0;
    this.BillingPaymentCardsApi = void 0;
    this.BillingPaymentCardsSetDefaultApi = void 0;
    this.BillingSubscriptionBillingInformationApi = void 0;
    this.BillingTransactionsApi = void 0;
    this.CannedRepliesApi = void 0;
    this.CommonStoreApi = void 0;
    this.CommunicationApi = void 0;
    this.CompanyApi = void 0;
    this.CompanyInvitationsApi = void 0;
    this.CompanyLogoApi = void 0;
    this.CompanySettingsApi = void 0;
    this.CompanyCreateCompanyApi = void 0;
    this.CountriesApi = void 0;
    this.CreditNotesCreditNoteApi = void 0;
    this.CreditNotesCreditNoteClientsApi = void 0;
    this.CreditNotesShoptetCreditNoteCancelItemsApi = void 0;
    this.CreditNotesShoptetCreditNoteRestockApi = void 0;
    this.CreditNotesShoptetInvoiceApi = void 0;
    this.CurrenciesApi = void 0;
    this.CustomFieldsApi = void 0;
    this.DashboardDeadlinesApi = void 0;
    this.DashboardLastMessagesApi = void 0;
    this.DashboardLastRatingCommentsApi = void 0;
    this.DashboardSettingsApi = void 0;
    this.DashboardStatsApi = void 0;
    this.DashboardUserSettingsApi = void 0;
    this.DhlFreightAccountApi = void 0;
    this.DhlLocationsApi = void 0;
    this.DisableAccountApi = void 0;
    this.DocumentCreateApi = void 0;
    this.DocumentTypesApi = void 0;
    this.EmailSettingApi = void 0;
    this.LanguagesApi = void 0;
    this.LaunchpadApi = void 0;
    this.MarketplaceInstalledPluginApi = void 0;
    this.MarketplaceInstalledPluginClientSetupApi = void 0;
    this.MarketplaceInstalledPluginUninstallApi = void 0;
    this.MarketplacePluginApi = void 0;
    this.MarketplacePluginInstallApi = void 0;
    this.MarketplaceRemarketingSettingsApi = void 0;
    this.MarketplaceSupplierApi = void 0;
    this.NotificationsApi = void 0;
    this.NotificationsLatestNotificationIdApi = void 0;
    this.NotificationsMarkAllAsReadApi = void 0;
    this.NotificationsMarkAsReadApi = void 0;
    this.NotificationsMarkAsUnreadApi = void 0;
    this.NotificationsNotificationSettingsApi = void 0;
    this.OnboardingCompanyOnboardingStepApi = void 0;
    this.OnboardingPlatformIntegrationConnectAccountApi = void 0;
    this.OrderProviderTypesApi = void 0;
    this.OrderProvidersApi = void 0;
    this.OrdersApi = void 0;
    this.OrdersDataRetentionApi = void 0;
    this.OrdersSampleApi = void 0;
    this.PortalMigrationGuidePortalIntegratedApi = void 0;
    this.PortalFormApi = void 0;
    this.PortalFormDesignApi = void 0;
    this.PortalFormSettingsApi = void 0;
    this.PortalFormBlockApi = void 0;
    this.PortalFormFormStringsApi = void 0;
    this.ProcessStepsApi = void 0;
    this.ProductCustomFieldsApi = void 0;
    this.ProductsProductsApi = void 0;
    this.QrCodeRefundApi = void 0;
    this.RefundAccountsApi = void 0;
    this.RefundBatchApi = void 0;
    this.RefundBatchRevertApi = void 0;
    this.RefundOptionsApi = void 0;
    this.RefundRequestApi = void 0;
    this.RefundSettingApi = void 0;
    this.RetinoShippingProfileApi = void 0;
    this.RetinoShippingShippingBulkActionApi = void 0;
    this.RetinoShippingShippingCreateApi = void 0;
    this.RetinoShippingShippingListApi = void 0;
    this.RolesApi = void 0;
    this.SearchApi = void 0;
    this.SearchModalUsageLogApi = void 0;
    this.ShippingApi = void 0;
    this.ShippingAddressApi = void 0;
    this.ShippingAddressSetForCpsApi = void 0;
    this.ShippingContractsApi = void 0;
    this.ShippingPortalShippingFormProfileApi = void 0;
    this.ShippingProvidersApi = void 0;
    this.ShippingRequestsApi = void 0;
    this.ShippingRequestsCreateTransportApi = void 0;
    this.ShippingSettingsApi = void 0;
    this.ShippingTypesApi = void 0;
    this.ShippingTypesCreateTransportApi = void 0;
    this.ShippingAdditionalContractSettingsApi = void 0;
    this.ShippingAddressesNewApi = void 0;
    this.ShippingContractsNewApi = void 0;
    this.ShippingContractsSettingsApi = void 0;
    this.ShippingCpsRoutesApi = void 0;
    this.ShippingOptionsApi = void 0;
    this.ShippingRoutesApi = void 0;
    this.ShippingShippingProfileApi = void 0;
    this.ShippingShippingCancelApi = void 0;
    this.ShippingShippingConfirmApi = void 0;
    this.ShippingShippingDeclineApi = void 0;
    this.ShippingShippingListApi = void 0;
    this.ShippingShopPaidRoutePriceApi = void 0;
    this.ShippingShopPaidShippingProfileApi = void 0;
    this.ShippingShopPaidShippingProfileActivateApi = void 0;
    this.ShippingShopPaidShippingProfileDeactivateApi = void 0;
    this.ShippingShopPaidShippingProfileUsage_reportApi = void 0;
    this.StatesApi = void 0;
    this.StatsAllUsersApi = void 0;
    this.StatsAvgTimeToCloseApi = void 0;
    this.StatsOpenClosedApi = void 0;
    this.StatsOverallProductCustomFieldsApi = void 0;
    this.StatsProductCustomFieldsApi = void 0;
    this.StatsRatingCommentsApi = void 0;
    this.StatsRetinoqualityApi = void 0;
    this.StatsReturnRateApi = void 0;
    this.StatsReturnedProductsApi = void 0;
    this.StatsScoreboardApi = void 0;
    this.StatsTotalOpenApi = void 0;
    this.StripeInvoicePayApi = void 0;
    this.StripePaymentMethodApi = void 0;
    this.StripePaymentMethodAttachApi = void 0;
    this.StripePaymentMethodDefaultApi = void 0;
    this.StripeSetupIntentApi = void 0;
    this.SubscriptionsApplyPromoCodeApi = void 0;
    this.SubscriptionsPriceApi = void 0;
    this.SubscriptionsProductApi = void 0;
    this.SubscriptionsPromotionCodeApi = void 0;
    this.SubscriptionsSubscriptionApi = void 0;
    this.SubscriptionsSubscriptionsStateApi = void 0;
    this.SubscriptionsSubscriptionsStateUpcomingPaymentApi = void 0;
    this.TagsApi = void 0;
    this.TicketCodeSeriesApi = void 0;
    this.TicketDetailSectionsApi = void 0;
    this.TicketProductsApi = void 0;
    this.TicketRefundOptionsApi = void 0;
    this.TicketTypesApi = void 0;
    this.TicketViewsApi = void 0;
    this.TicketsApi = void 0;
    this.TicketsBulkActionsApi = void 0;
    this.TicketsCloseApi = void 0;
    this.TicketsCustomerHistoryApi = void 0;
    this.TicketsGeneratePdfApi = void 0;
    this.TicketsReopenApi = void 0;
    this.TicketsDocumentsApi = void 0;
    this.TicketsHistoryApi = void 0;
    this.TicketsInternalNotesApi = void 0;
    this.TicketsMessagesApi = void 0;
    this.TicketsProductsApi = void 0;
    this.TicketsRatingApi = void 0;
    this.TicketsSmsMessagesApi = void 0;
    this.TicketsTransportApi = void 0;
    this.TicketsTriggerLogsApi = void 0;
    this.TicketsVerifyApi = void 0;
    this.TicketsBulkActionApi = void 0;
    this.TicketsHasBeenCreatedRecentlyApi = void 0;
    this.TriggerConditionsTypesApi = void 0;
    this.TriggerDelayedActionsApi = void 0;
    this.TriggerLogsApi = void 0;
    this.TriggerLogsRerunApi = void 0;
    this.TriggersApi = void 0;
    this.TriggersTypesApi = void 0;
    this.TypesProductCustomFieldsApi = void 0;
    this.TypesStringsApi = void 0;
    this.UserSignatureApi = void 0;
    this.UsersApi = void 0;
    this.UsersRevokeAccessApi = void 0;
    this.UsersRoleApi = void 0;
    this.VoucherClientsApi = void 0;
    this.VouchersApi = void 0;
    this.initApis();
  }
  initApis() {
    this.ActivitiesApi = new ActivitiesApi(this);
    this.AddFlagApi = new AddFlagApi(this);
    this.AiChatCompletionApi = new AiChatCompletionApi(this);
    this.ApiV2TokenApi = new ApiV2TokenApi(this);
    this.ApiV2TokenRollApi = new ApiV2TokenRollApi(this);
    this.ApiV2WebhookEndpointsApi = new ApiV2WebhookEndpointsApi(this);
    this.ApiV2WebhookEndpointsRollSecretApi = new ApiV2WebhookEndpointsRollSecretApi(this);
    this.ApiV2WebhookEndpointsTestApi = new ApiV2WebhookEndpointsTestApi(this);
    this.ApiV2WebhookEndpointsRequestsApi = new ApiV2WebhookEndpointsRequestsApi(this);
    this.ApiV2WebhookEndpointsWebhooksRetryApi = new ApiV2WebhookEndpointsWebhooksRetryApi(this);
    this.AuthApiTokenRegenerateApi = new AuthApiTokenRegenerateApi(this);
    this.AuthUserApi = new AuthUserApi(this);
    this.AuthUserPasswordApi = new AuthUserPasswordApi(this);
    this.BadgeBadgeSettingsApi = new BadgeBadgeSettingsApi(this);
    this.BillingInformationApi = new BillingInformationApi(this);
    this.BillingBilledInvoicesUnpaidApi = new BillingBilledInvoicesUnpaidApi(this);
    this.BillingBilledInvoicesUnpaidPayApi = new BillingBilledInvoicesUnpaidPayApi(this);
    this.BillingInvoicesApi = new BillingInvoicesApi(this);
    this.BillingPaymentCardsApi = new BillingPaymentCardsApi(this);
    this.BillingPaymentCardsSetDefaultApi = new BillingPaymentCardsSetDefaultApi(this);
    this.BillingSubscriptionBillingInformationApi = new BillingSubscriptionBillingInformationApi(this);
    this.BillingTransactionsApi = new BillingTransactionsApi(this);
    this.CannedRepliesApi = new CannedRepliesApi(this);
    this.CommonStoreApi = new CommonStoreApi(this);
    this.CommunicationApi = new CommunicationApi(this);
    this.CompanyApi = new CompanyApi(this);
    this.CompanyInvitationsApi = new CompanyInvitationsApi(this);
    this.CompanyLogoApi = new CompanyLogoApi(this);
    this.CompanySettingsApi = new CompanySettingsApi(this);
    this.CompanyCreateCompanyApi = new CompanyCreateCompanyApi(this);
    this.CountriesApi = new CountriesApi(this);
    this.CreditNotesCreditNoteApi = new CreditNotesCreditNoteApi(this);
    this.CreditNotesCreditNoteClientsApi = new CreditNotesCreditNoteClientsApi(this);
    this.CreditNotesShoptetCreditNoteCancelItemsApi = new CreditNotesShoptetCreditNoteCancelItemsApi(this);
    this.CreditNotesShoptetCreditNoteRestockApi = new CreditNotesShoptetCreditNoteRestockApi(this);
    this.CreditNotesShoptetInvoiceApi = new CreditNotesShoptetInvoiceApi(this);
    this.CurrenciesApi = new CurrenciesApi(this);
    this.CustomFieldsApi = new CustomFieldsApi(this);
    this.DashboardDeadlinesApi = new DashboardDeadlinesApi(this);
    this.DashboardLastMessagesApi = new DashboardLastMessagesApi(this);
    this.DashboardLastRatingCommentsApi = new DashboardLastRatingCommentsApi(this);
    this.DashboardSettingsApi = new DashboardSettingsApi(this);
    this.DashboardStatsApi = new DashboardStatsApi(this);
    this.DashboardUserSettingsApi = new DashboardUserSettingsApi(this);
    this.DhlFreightAccountApi = new DhlFreightAccountApi(this);
    this.DhlLocationsApi = new DhlLocationsApi(this);
    this.DisableAccountApi = new DisableAccountApi(this);
    this.DocumentCreateApi = new DocumentCreateApi(this);
    this.DocumentTypesApi = new DocumentTypesApi(this);
    this.EmailSettingApi = new EmailSettingApi(this);
    this.LanguagesApi = new LanguagesApi(this);
    this.LaunchpadApi = new LaunchpadApi(this);
    this.MarketplaceInstalledPluginApi = new MarketplaceInstalledPluginApi(this);
    this.MarketplaceInstalledPluginClientSetupApi = new MarketplaceInstalledPluginClientSetupApi(this);
    this.MarketplaceInstalledPluginUninstallApi = new MarketplaceInstalledPluginUninstallApi(this);
    this.MarketplacePluginApi = new MarketplacePluginApi(this);
    this.MarketplacePluginInstallApi = new MarketplacePluginInstallApi(this);
    this.MarketplaceRemarketingSettingsApi = new MarketplaceRemarketingSettingsApi(this);
    this.MarketplaceSupplierApi = new MarketplaceSupplierApi(this);
    this.NotificationsApi = new NotificationsApi(this);
    this.NotificationsLatestNotificationIdApi = new NotificationsLatestNotificationIdApi(this);
    this.NotificationsMarkAllAsReadApi = new NotificationsMarkAllAsReadApi(this);
    this.NotificationsMarkAsReadApi = new NotificationsMarkAsReadApi(this);
    this.NotificationsMarkAsUnreadApi = new NotificationsMarkAsUnreadApi(this);
    this.NotificationsNotificationSettingsApi = new NotificationsNotificationSettingsApi(this);
    this.OnboardingCompanyOnboardingStepApi = new OnboardingCompanyOnboardingStepApi(this);
    this.OnboardingPlatformIntegrationConnectAccountApi = new OnboardingPlatformIntegrationConnectAccountApi(this);
    this.OrderProviderTypesApi = new OrderProviderTypesApi(this);
    this.OrderProvidersApi = new OrderProvidersApi(this);
    this.OrdersApi = new OrdersApi(this);
    this.OrdersDataRetentionApi = new OrdersDataRetentionApi(this);
    this.OrdersSampleApi = new OrdersSampleApi(this);
    this.PortalMigrationGuidePortalIntegratedApi = new PortalMigrationGuidePortalIntegratedApi(this);
    this.PortalFormApi = new PortalFormApi(this);
    this.PortalFormDesignApi = new PortalFormDesignApi(this);
    this.PortalFormSettingsApi = new PortalFormSettingsApi(this);
    this.PortalFormBlockApi = new PortalFormBlockApi(this);
    this.PortalFormFormStringsApi = new PortalFormFormStringsApi(this);
    this.ProcessStepsApi = new ProcessStepsApi(this);
    this.ProductCustomFieldsApi = new ProductCustomFieldsApi(this);
    this.ProductsProductsApi = new ProductsProductsApi(this);
    this.QrCodeRefundApi = new QrCodeRefundApi(this);
    this.RefundAccountsApi = new RefundAccountsApi(this);
    this.RefundBatchApi = new RefundBatchApi(this);
    this.RefundBatchRevertApi = new RefundBatchRevertApi(this);
    this.RefundOptionsApi = new RefundOptionsApi(this);
    this.RefundRequestApi = new RefundRequestApi(this);
    this.RefundSettingApi = new RefundSettingApi(this);
    this.RetinoShippingProfileApi = new RetinoShippingProfileApi(this);
    this.RetinoShippingShippingBulkActionApi = new RetinoShippingShippingBulkActionApi(this);
    this.RetinoShippingShippingCreateApi = new RetinoShippingShippingCreateApi(this);
    this.RetinoShippingShippingListApi = new RetinoShippingShippingListApi(this);
    this.RolesApi = new RolesApi(this);
    this.SearchApi = new SearchApi(this);
    this.SearchModalUsageLogApi = new SearchModalUsageLogApi(this);
    this.ShippingApi = new ShippingApi(this);
    this.ShippingAddressApi = new ShippingAddressApi(this);
    this.ShippingAddressSetForCpsApi = new ShippingAddressSetForCpsApi(this);
    this.ShippingContractsApi = new ShippingContractsApi(this);
    this.ShippingPortalShippingFormProfileApi = new ShippingPortalShippingFormProfileApi(this);
    this.ShippingProvidersApi = new ShippingProvidersApi(this);
    this.ShippingRequestsApi = new ShippingRequestsApi(this);
    this.ShippingRequestsCreateTransportApi = new ShippingRequestsCreateTransportApi(this);
    this.ShippingSettingsApi = new ShippingSettingsApi(this);
    this.ShippingTypesApi = new ShippingTypesApi(this);
    this.ShippingTypesCreateTransportApi = new ShippingTypesCreateTransportApi(this);
    this.ShippingAdditionalContractSettingsApi = new ShippingAdditionalContractSettingsApi(this);
    this.ShippingAddressesNewApi = new ShippingAddressesNewApi(this);
    this.ShippingContractsNewApi = new ShippingContractsNewApi(this);
    this.ShippingContractsSettingsApi = new ShippingContractsSettingsApi(this);
    this.ShippingCpsRoutesApi = new ShippingCpsRoutesApi(this);
    this.ShippingOptionsApi = new ShippingOptionsApi(this);
    this.ShippingRoutesApi = new ShippingRoutesApi(this);
    this.ShippingShippingProfileApi = new ShippingShippingProfileApi(this);
    this.ShippingShippingCancelApi = new ShippingShippingCancelApi(this);
    this.ShippingShippingConfirmApi = new ShippingShippingConfirmApi(this);
    this.ShippingShippingDeclineApi = new ShippingShippingDeclineApi(this);
    this.ShippingShippingListApi = new ShippingShippingListApi(this);
    this.ShippingShopPaidRoutePriceApi = new ShippingShopPaidRoutePriceApi(this);
    this.ShippingShopPaidShippingProfileApi = new ShippingShopPaidShippingProfileApi(this);
    this.ShippingShopPaidShippingProfileActivateApi = new ShippingShopPaidShippingProfileActivateApi(this);
    this.ShippingShopPaidShippingProfileDeactivateApi = new ShippingShopPaidShippingProfileDeactivateApi(this);
    this.ShippingShopPaidShippingProfileUsage_reportApi = new ShippingShopPaidShippingProfileUsage_reportApi(this);
    this.StatesApi = new StatesApi(this);
    this.StatsAllUsersApi = new StatsAllUsersApi(this);
    this.StatsAvgTimeToCloseApi = new StatsAvgTimeToCloseApi(this);
    this.StatsOpenClosedApi = new StatsOpenClosedApi(this);
    this.StatsOverallProductCustomFieldsApi = new StatsOverallProductCustomFieldsApi(this);
    this.StatsProductCustomFieldsApi = new StatsProductCustomFieldsApi(this);
    this.StatsRatingCommentsApi = new StatsRatingCommentsApi(this);
    this.StatsRetinoqualityApi = new StatsRetinoqualityApi(this);
    this.StatsReturnRateApi = new StatsReturnRateApi(this);
    this.StatsReturnedProductsApi = new StatsReturnedProductsApi(this);
    this.StatsScoreboardApi = new StatsScoreboardApi(this);
    this.StatsTotalOpenApi = new StatsTotalOpenApi(this);
    this.StripeInvoicePayApi = new StripeInvoicePayApi(this);
    this.StripePaymentMethodApi = new StripePaymentMethodApi(this);
    this.StripePaymentMethodAttachApi = new StripePaymentMethodAttachApi(this);
    this.StripePaymentMethodDefaultApi = new StripePaymentMethodDefaultApi(this);
    this.StripeSetupIntentApi = new StripeSetupIntentApi(this);
    this.SubscriptionsApplyPromoCodeApi = new SubscriptionsApplyPromoCodeApi(this);
    this.SubscriptionsPriceApi = new SubscriptionsPriceApi(this);
    this.SubscriptionsProductApi = new SubscriptionsProductApi(this);
    this.SubscriptionsPromotionCodeApi = new SubscriptionsPromotionCodeApi(this);
    this.SubscriptionsSubscriptionApi = new SubscriptionsSubscriptionApi(this);
    this.SubscriptionsSubscriptionsStateApi = new SubscriptionsSubscriptionsStateApi(this);
    this.SubscriptionsSubscriptionsStateUpcomingPaymentApi = new SubscriptionsSubscriptionsStateUpcomingPaymentApi(this);
    this.TagsApi = new TagsApi(this);
    this.TicketCodeSeriesApi = new TicketCodeSeriesApi(this);
    this.TicketDetailSectionsApi = new TicketDetailSectionsApi(this);
    this.TicketProductsApi = new TicketProductsApi(this);
    this.TicketRefundOptionsApi = new TicketRefundOptionsApi(this);
    this.TicketTypesApi = new TicketTypesApi(this);
    this.TicketViewsApi = new TicketViewsApi(this);
    this.TicketsApi = new TicketsApi(this);
    this.TicketsBulkActionsApi = new TicketsBulkActionsApi(this);
    this.TicketsCloseApi = new TicketsCloseApi(this);
    this.TicketsCustomerHistoryApi = new TicketsCustomerHistoryApi(this);
    this.TicketsGeneratePdfApi = new TicketsGeneratePdfApi(this);
    this.TicketsReopenApi = new TicketsReopenApi(this);
    this.TicketsDocumentsApi = new TicketsDocumentsApi(this);
    this.TicketsHistoryApi = new TicketsHistoryApi(this);
    this.TicketsInternalNotesApi = new TicketsInternalNotesApi(this);
    this.TicketsMessagesApi = new TicketsMessagesApi(this);
    this.TicketsProductsApi = new TicketsProductsApi(this);
    this.TicketsRatingApi = new TicketsRatingApi(this);
    this.TicketsSmsMessagesApi = new TicketsSmsMessagesApi(this);
    this.TicketsTransportApi = new TicketsTransportApi(this);
    this.TicketsTriggerLogsApi = new TicketsTriggerLogsApi(this);
    this.TicketsVerifyApi = new TicketsVerifyApi(this);
    this.TicketsBulkActionApi = new TicketsBulkActionApi(this);
    this.TicketsHasBeenCreatedRecentlyApi = new TicketsHasBeenCreatedRecentlyApi(this);
    this.TriggerConditionsTypesApi = new TriggerConditionsTypesApi(this);
    this.TriggerDelayedActionsApi = new TriggerDelayedActionsApi(this);
    this.TriggerLogsApi = new TriggerLogsApi(this);
    this.TriggerLogsRerunApi = new TriggerLogsRerunApi(this);
    this.TriggersApi = new TriggersApi(this);
    this.TriggersTypesApi = new TriggersTypesApi(this);
    this.TypesProductCustomFieldsApi = new TypesProductCustomFieldsApi(this);
    this.TypesStringsApi = new TypesStringsApi(this);
    this.UserSignatureApi = new UserSignatureApi(this);
    this.UsersApi = new UsersApi(this);
    this.UsersRevokeAccessApi = new UsersRevokeAccessApi(this);
    this.UsersRoleApi = new UsersRoleApi(this);
    this.VoucherClientsApi = new VoucherClientsApi(this);
    this.VouchersApi = new VouchersApi(this);
  }
}
;// ./react/subscriptions/featureUpsellStore.ts
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }

let FeatureUpsellStore = (_class = class FeatureUpsellStore {
  constructor() {
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
    _initializerDefineProperty(this, "feature", _descriptor2, this);
    _initializerDefineProperty(this, "proPrice", _descriptor3, this);
    _initializerDefineProperty(this, "isPriceLoading", _descriptor4, this);
    this.priceLoaded = false;
    _initializerDefineProperty(this, "loadPrice", _descriptor5, this);
    (0,mobx_esm/* makeObservable */.Gn)(this);
  }
  open(feature) {
    this.feature = feature;
    this.isOpen = true;
  }
  close() {
    this.isOpen = false;
    this.feature = null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "feature", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "proPrice", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPriceLoading", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "open", [mobx_esm/* action */.XI], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [mobx_esm/* action */.XI], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loadPrice", [mobx_esm/* action */.XI], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async (api, billingCurrency) => {
      if (this.priceLoaded || this.isPriceLoading) return;
      this.isPriceLoading = true;
      try {
        const prices = await api.SubscriptionsPriceApi.list();
        // Find the highest-tier MANAGER price (PRO) — tier_level comes from the backend ManagerTierLevel enum
        const proPrice = prices.filter((0,mobx_esm/* action */.XI)(p => p.product.internal_type === 'MANAGER' && p.currency === billingCurrency)).sort((0,mobx_esm/* action */.XI)((a, b) => b.tier_level - a.tier_level))[0];
        this.proPrice = proPrice || null;
        this.priceLoaded = true;
      } finally {
        this.isPriceLoading = false;
      }
    };
  }
})), _class);
const featureUpsellStore = new FeatureUpsellStore();
/* harmony default export */ const subscriptions_featureUpsellStore = (featureUpsellStore);
// EXTERNAL MODULE: ./react/helpers/toast.tsx
var toast = __webpack_require__(15072);
;// ./react/stores/error_handlers.tsx



function handleFeatureRequired(responseBody) {
  subscriptions_featureUpsellStore.open(responseBody.feature);
}
function handleProtectedError(responseBody) {
  toast/* default */.A.error( /*#__PURE__*/react.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/react.createElement("div", null, responseBody.message), /*#__PURE__*/react.createElement("div", null, responseBody.usages.map((usage, i) => usage.url ? /*#__PURE__*/react.createElement("a", {
    key: i,
    href: usage.url,
    className: "text-sm font-medium text-indigo-600 hover:text-indigo-800"
  }, usage.name) : /*#__PURE__*/react.createElement("p", {
    key: i,
    className: "text-sm font-medium text-indigo-600"
  }, usage.name)))));
}
// EXTERNAL MODULE: ./node_modules/universal-cookie/esm/index.mjs
var universal_cookie_esm = __webpack_require__(51145);
;// ./react/api/middlewares.ts
function middlewares_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function middlewares_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? middlewares_ownKeys(Object(t), !0).forEach(function (r) { middlewares_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : middlewares_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function middlewares_defineProperty(obj, key, value) { key = middlewares_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function middlewares_toPropertyKey(t) { var i = middlewares_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function middlewares_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */




class AddCsrfHeaderMiddleware {
  async pre(context) {
    const cookies = new universal_cookie_esm/* default */.A();
    context.init.headers = middlewares_objectSpread(middlewares_objectSpread({}, context.init.headers), {}, {
      'X-CSRFToken': cookies.get('csrftoken')
    });
    return context;
  }
}
class HandleErrorsMiddleware {
  constructor(history, language) {
    this.history = void 0;
    this.language = void 0;
    this.history = history;
    this.language = language;
  }
  async onError(context) {
    if (!context.response || context.response.status === 0) {
      ui/* toast */.oR.error(gettext("We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection."));
    }
  }
  async post(_ref) {
    let {
      response
    } = _ref;
    if (response.type === 'error') {
      ui/* toast */.oR.error(gettext("We couldn't connect to Retino servers. We'll keep trying but there may be a problem with your connection."));
    } else if (response.status === 401) {
      window.location = "".concat(codegen_authRoutes.authLogin({
        lang: this.language
      }), "?next=").concat(this.history.location.pathname);
    } else if (response.status === 403) {
      const cloned = response.clone();
      const data = await cloned.json();
      if (data.code === 'feature_required') {
        handleFeatureRequired(data);
        // Replace response body with empty object so Form.tsx error handling
        // finds no field errors and shows no error toasts. The modal handles the UX.
        return new Response(JSON.stringify({}), {
          status: 403
        });
      }
    } else if (response.status === 409) {
      const data = await response.json();
      if (data.code && data.code === 'protected_error') {
        handleProtectedError(data);
      }
    } else if (response.status === 500) {
      ui/* toast */.oR.error(gettext('We were not able to process your request. Our developers have been informed.'));
    } else if (response.status >= 501) {
      ui/* toast */.oR.error(gettext('We were not able to process your request.'));
    }
  }
}
/* harmony default export */ const middlewares = ({
  AddCsrfHeaderMiddleware,
  HandleErrorsMiddleware
});
;// ./react/api/index.tsx





const ApiContext = /*#__PURE__*/(0,react.createContext)(null);
const useApi = () => (0,helpers_utils/* useContextSafe */.qr)(ApiContext);
function ApiProvider(_ref) {
  let {
    children
  } = _ref;
  const history = (0,hooks/* useHistory */.W6)();
  const [api] = (0,react.useState)(() => new ApiClient({
    baseUrl: "".concat(window.location.origin, "/api/internal/private"),
    middlewares: [new middlewares.AddCsrfHeaderMiddleware(), new middlewares.HandleErrorsMiddleware(history, window.appState.lang)],
    getHeaders: () => ({
      'Accept-Language': window.appState.lang,
      'Content-Type': 'application/json',
      'X-Retino-Frontend': window.appState.bundleHash
    })
  }));
  return /*#__PURE__*/react.createElement(ApiContext.Provider, {
    value: api
  }, children);
}

/* harmony default export */ const react_api = (useApi);
// EXTERNAL MODULE: ./react/stores/constants.ts
var constants = __webpack_require__(25193);
;// ./react/onboarding/CreateCompany.tsx





function CreateCompany(_ref) {
  let {
    onCreate
  } = _ref;
  const api = react_api();
  const [name, setName] = (0,react.useState)('');
  const [language, setLanguage] = (0,react.useState)('cs');
  const [errors, setErrors] = (0,react.useState)({});
  const isValid = () => {
    setErrors({});
    if (name.length === 0) {
      setErrors({
        name: gettext('This field is required')
      });
      return false;
    }
    return true;
  };
  const [handleCreateCompany, isLoading] = (0,hooks/* useAsyncFunction */.m_)(async () => {
    if (!isValid()) return;
    const createdCompany = await api.CompanyCreateCompanyApi.create({
      request: {
        name: {
          [language]: name
        },
        language
      }
    });
    onCreate(createdCompany.id);
  });
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: () => handleCreateCompany()
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    autoFocus: true,
    label: pgettext('company', 'Account name'),
    placeholder: pgettext('company', 'Account name'),
    value: name,
    error: errors.name,
    onChange: value => setName(value)
  })), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('Company language')
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start gap-4"
  }, constants/* supportedLanguages */.Uv.map(lang => /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    value: language === lang,
    onChange: () => setLanguage(lang),
    label: constants/* allLanguagesLocalised */.P8[lang]
  })))), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    submit: true,
    fluid: true,
    loading: isLoading
  }, gettext('Create account')))));
}
/* harmony default export */ const onboarding_CreateCompany = (CreateCompany);
;// ./react/components/Launchpad.tsx







function Launchpad() {
  const api = react_api();
  const [isCreating, setIsCreating] = (0,react.useState)(false);
  const [data, setData] = (0,react.useState)(null);
  const [createCompany, setCreateCompany] = (0,react.useState)(false);
  const history = (0,hooks/* useHistory */.W6)();
  async function load() {
    const response = await api.LaunchpadApi.retrieve();
    setData(response);
  }
  const [handleLoad, isLoading] = (0,hooks/* useAsyncFunction */.m_)(load);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  const handleOnCreate = companyId => {
    setIsCreating(true);
    window.location.replace("/company/set-active-account/".concat(companyId, "/"));
  };
  const getCompanyUrl = companyId => {
    const baseUrl = codegen_authRoutes.companySetActiveAccountCompanyDetail({
      companyId,
      lang: window.appState.lang
    });
    const nextUrl = new URLSearchParams(history.location.search).get('next');
    if (!nextUrl) return baseUrl;
    return "".concat(baseUrl, "?next=").concat(nextUrl);
  };
  if (isLoading || isCreating || data === null) {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col items-center justify-center p-8"
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
      size: "huge"
    })));
  }
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("h2", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Switch company')), /*#__PURE__*/react.createElement("div", {
    className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, data.member_accounts.map(company => /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("a", {
    href: getCompanyUrl(company.id)
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    fluid: true,
    grayLink: company.is_disabled
  }, (0,helpers_utils/* currentLanguage */.aS)(company.name))))), createCompany ? /*#__PURE__*/react.createElement(onboarding_CreateCompany, {
    onCreate: handleOnCreate
  }) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    fluid: true,
    link: true,
    onClick: () => setCreateCompany(true)
  }, gettext('Create new company'))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("a", {
    href: codegen_authRoutes.authLogout({
      lang: window.appState.lang
    })
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    fluid: true,
    link: true
  }, gettext('Log out'))))), data.also_available.length > 0 && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Divider */.cG, null), data.also_available.map(company => /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("a", {
    href: getCompanyUrl(company.id)
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    fluid: true,
    grayLink: company.is_disabled
  }, (0,helpers_utils/* currentLanguage */.aS)(company.name))))))))));
}
function LaunchpadWrapper() {
  // User is logged in, so we can provide the private API context
  return /*#__PURE__*/react.createElement(ApiProvider, null, /*#__PURE__*/react.createElement(Launchpad, null));
}
/* harmony default export */ const components_Launchpad = (LaunchpadWrapper);
// EXTERNAL MODULE: ./react/components/ScrollToTop.tsx
var ScrollToTop = __webpack_require__(53199);
// EXTERNAL MODULE: ./react/ui/toast/ToastStore.ts
var ToastStore = __webpack_require__(2102);
;// ./react/contexts/AuthContextProviders.tsx




function AuthContextProviders(_ref) {
  let {
    children
  } = _ref;
  const [toastStore, setToastStore] = (0,react.useState)(() => new ToastStore/* default */.Ay());
  (0,react.useEffect)(() => {
    window.appState.toastStore = toastStore;
  }, []);
  return /*#__PURE__*/react.createElement(public_api/* PublicApiProvider */.Fm, null, /*#__PURE__*/react.createElement(ToastStore/* ToastStoreContext */.yG.Provider, {
    value: toastStore
  }, children));
}
/* harmony default export */ const contexts_AuthContextProviders = ((0,mobxreact_esm/* observer */.PA)(AuthContextProviders));
// EXTERNAL MODULE: ./react/layouts/main-sidebar/LogoIcon.tsx
var LogoIcon = __webpack_require__(56858);
;// ./react/layouts/AuthLayout.tsx


function AuthLayout(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex min-h-screen flex-col justify-center bg-gray-50 py-12 sm:px-6 lg:px-8"
  }, /*#__PURE__*/react.createElement("div", {
    className: "sm:mx-auto sm:w-full sm:max-w-md"
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-auto mb-6 w-40 text-brand-700"
  }, /*#__PURE__*/react.createElement(LogoIcon/* default */.A, null)), children, /*#__PURE__*/react.createElement("div", {
    className: "mt-4 text-center text-xs text-gray-400"
  }, "\xA9 2017\u2013", new Date().getFullYear(), " Retino.cz s.r.o. \xA0|\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com/obchodni-podminky/",
    className: "underline"
  }, pgettext('Nominative, name of the document', 'Terms of Service')), "\xA0|\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com/ochrana-osobnich-udaju/",
    className: "underline"
  }, pgettext('Nominative, name of the document', 'Privacy Policy')))));
}
/* harmony default export */ const layouts_AuthLayout = (AuthLayout);
// EXTERNAL MODULE: ./react/public-api/codegen/enums.ts
var enums = __webpack_require__(2538);
;// ./react/public-api/codegen/index.ts

;// ./react/onboarding/stores/RegistrationStore.ts
var _dec, _dec2, _dec3, _dec4, _dec5, RegistrationStore_class, RegistrationStore_descriptor, RegistrationStore_descriptor2, RegistrationStore_descriptor3;
function RegistrationStore_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RegistrationStore_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RegistrationStore_ownKeys(Object(t), !0).forEach(function (r) { RegistrationStore_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RegistrationStore_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function RegistrationStore_defineProperty(obj, key, value) { key = RegistrationStore_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function RegistrationStore_toPropertyKey(t) { var i = RegistrationStore_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function RegistrationStore_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function RegistrationStore_initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function RegistrationStore_applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function RegistrationStore_initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }






const pipedriveTicketsPerMonthOptions = [{
  value: 21,
  label: '< 10'
}, {
  value: 22,
  label: '10-50'
}, {
  value: 23,
  label: '50-100'
}, {
  value: 24,
  label: '100-200'
}, {
  value: 25,
  label: '200+'
}];
const pipedriveShipmentsPerMonthOptions = [{
  value: 21,
  label: ' < 100'
}, {
  value: 22,
  label: '100-500'
}, {
  value: 23,
  label: '500-1000'
}, {
  value: 24,
  label: '1 000-5 000'
}, {
  value: 25,
  label: '5 000-10 000'
}, {
  value: 26,
  label: '10 000-20 000'
}, {
  value: 27,
  label: '20 000+'
}];
const languageOptions = [{
  value: 'cs',
  label: constants/* allLanguagesLocalised */.P8.cs
}, {
  value: 'en',
  label: constants/* allLanguagesLocalised */.P8.en
}, {
  value: 'hu',
  label: constants/* allLanguagesLocalised */.P8.hu
}, {
  value: 'ro',
  label: constants/* allLanguagesLocalised */.P8.ro
}];
const retinoDiscoveryOptions = [{
  value: 'store_platform_addons',
  label: gettext('Marketplace of the store platform (Shoptet, etc.)')
}, {
  value: 'webinar_event',
  label: gettext('Webinar or some other event')
}, {
  value: 'other_store',
  label: gettext("I've seen Retino on some other store")
}, {
  value: 'recommendation',
  label: gettext('By recommendation')
}, {
  value: 'advertisment',
  label: gettext('Advertisment')
}, {
  value: 'search_engine',
  label: gettext('Search engine (Google, Seznam, etc.)')
}];
const companyStepFields = ['account_name', 'estimated_monthly_tickets', 'estimated_monthly_shipments', 'shop_url', 'language'];
const productSelectStepFields = ['selected_products'];
let RegistrationStore = (_dec = mobx_esm/* action */.XI.bound, _dec2 = mobx_esm/* action */.XI.bound, _dec3 = mobx_esm/* action */.XI.bound, _dec4 = mobx_esm/* action */.XI.bound, _dec5 = mobx_esm/* action */.XI.bound, (RegistrationStore_class = class RegistrationStore {
  constructor(api) {
    RegistrationStore_initializerDefineProperty(this, "data", RegistrationStore_descriptor, this);
    RegistrationStore_initializerDefineProperty(this, "errors", RegistrationStore_descriptor2, this);
    // State
    RegistrationStore_initializerDefineProperty(this, "step", RegistrationStore_descriptor3, this);
    this.api = void 0;
    (0,mobx_esm/* makeObservable */.Gn)(this);
    this.data.language = window.appState.lang === 'cs' ? 'cs' : 'en';
    this.api = api;
  }
  loadFromSearch(search) {
    const searchParams = (0,helpers_utils/* parsedUrlSearchArrayValuesToSingleValues */.rs)((0,helpers_utils/* parseUrlSearch */.Lr)(search));
    this.data.email = searchParams.email ? String(searchParams.email) : '';
    this.data.portal = Boolean(searchParams.portal);
    this.data.utm_tags = {
      utm_source: searchParams.utm_source,
      utm_medium: searchParams.utm_medium,
      utm_content: searchParams.utm_content,
      utm_campaign: searchParams.utm_campaign
    };
  }
  async submit() {
    try {
      await this.api.AuthRegisterApi.create({
        request: this.data
      });
      return true;
    } catch (error) {
      if ((0,utils/* isResponse */.S)(error) && error.response.status === 400) {
        this.errors = await (0,utils/* getErrors */.Y)(error);
        if (this.errors) {
          const invalidCompanyStep = Object.keys(this.errors).some((0,mobx_esm/* action */.XI)(key => companyStepFields.includes(key)));
          if (invalidCompanyStep) {
            this.step = 'COMPANY';
          }
          const invalidProductSelectStep = Object.keys(this.errors).some((0,mobx_esm/* action */.XI)(key => productSelectStepFields.includes(key)));
          if (invalidProductSelectStep) {
            this.step = 'PRODUCT_SELECT';
          }
        }
      } else {
        toast/* default */.A.error(gettext('Oops. Something went wrong.'));
      }
    }
    return false;
  }
  async validateEmail() {
    const isUnique = Boolean(await this.api.AuthEmailAvailableApi.retrieve({
      email: this.data.email
    }));
    return isUnique;
  }
  updateData(data) {
    this.data = RegistrationStore_objectSpread(RegistrationStore_objectSpread({}, this.data), data);
  }
  nextStep() {
    switch (this.step) {
      case 'PRODUCT_SELECT':
        this.step = 'COMPANY';
        break;
      case 'COMPANY':
        this.step = 'USER';
        break;
      case 'USER':
        this.step = 'USER';
        break;
      default:
        this.step = 'PRODUCT_SELECT';
        break;
    }
  }
  prevStep() {
    switch (this.step) {
      case 'USER':
        this.step = 'COMPANY';
        break;
      case 'COMPANY':
        this.step = 'PRODUCT_SELECT';
        break;
      case 'PRODUCT_SELECT':
        this.step = 'PRODUCT_SELECT';
        break;
      default:
        this.step = 'PRODUCT_SELECT';
        break;
    }
  }
  static get estimatedMonthlyTicketsOptions() {
    return pipedriveTicketsPerMonthOptions;
  }
  static get estimatedMonthlyShipmentsOptions() {
    return pipedriveShipmentsPerMonthOptions;
  }
  static get languageOptions() {
    return languageOptions;
  }
  static get retinoDiscoveryOptions() {
    return retinoDiscoveryOptions;
  }
}, (RegistrationStore_descriptor = RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "data", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      email: '',
      password: '',
      full_name: '',
      account_name: '',
      estimated_monthly_tickets: null,
      estimated_monthly_shipments: null,
      selected_products: [],
      shop_url: '',
      language: enums/* BackendPublicEnums */.C.AccountRegisterLanguageEnum.EN,
      phone_number: '',
      retino_discovery: [],
      portal: false,
      use_referral_code: false,
      referral_code: ''
    };
  }
}), RegistrationStore_descriptor2 = RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "errors", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), RegistrationStore_descriptor3 = RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "step", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'PRODUCT_SELECT';
  }
}), RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "submit", [_dec], Object.getOwnPropertyDescriptor(RegistrationStore_class.prototype, "submit"), RegistrationStore_class.prototype), RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "validateEmail", [_dec2], Object.getOwnPropertyDescriptor(RegistrationStore_class.prototype, "validateEmail"), RegistrationStore_class.prototype), RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "updateData", [_dec3], Object.getOwnPropertyDescriptor(RegistrationStore_class.prototype, "updateData"), RegistrationStore_class.prototype), RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "nextStep", [_dec4], Object.getOwnPropertyDescriptor(RegistrationStore_class.prototype, "nextStep"), RegistrationStore_class.prototype), RegistrationStore_applyDecoratedDescriptor(RegistrationStore_class.prototype, "prevStep", [_dec5], Object.getOwnPropertyDescriptor(RegistrationStore_class.prototype, "prevStep"), RegistrationStore_class.prototype)), RegistrationStore_class));
/* harmony default export */ const stores_RegistrationStore = (RegistrationStore);
;// ./react/onboarding/components/CompanyRegistrationStep.tsx





function CompanyRegistrationStep(_ref) {
  var _store$errors, _store$errors2, _store$errors3, _store$errors4, _store$errors5, _store$data$use_refer, _store$errors7;
  let {
    store,
    onSubmit,
    isSubmitting
  } = _ref;
  const handleUpdateInput = fieldName => value => store.updateData({
    [fieldName]: value
  });
  const handleUpdateMultichoiceInput = fieldName => value => store.updateData({
    [fieldName]: (0,helpers_utils/* toggleItem */.g6)(store.data[fieldName], value)
  });
  const [isReferralCodeFromUrl, setIsReferralCodeFromUrl] = react.useState(false);
  (0,react.useEffect)(() => {
    if (store.data.referral_code) {
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get('referrer');
    if (referrer) {
      store.updateData({
        referral_code: referrer,
        use_referral_code: true
      });
      setIsReferralCodeFromUrl(true);
    }
  }, []);
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: onSubmit,
    loading: isSubmitting
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    error: (_store$errors = store.errors) === null || _store$errors === void 0 ? void 0 : _store$errors.account_name,
    name: "eshop-name",
    value: store.data.account_name,
    placeholder: gettext('Amazon'),
    onChange: handleUpdateInput('account_name'),
    required: true,
    label: gettext('Store name')
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    error: (_store$errors2 = store.errors) === null || _store$errors2 === void 0 ? void 0 : _store$errors2.shop_url,
    name: "url",
    value: store.data.shop_url,
    onChange: handleUpdateInput('shop_url'),
    required: true,
    label: gettext('Store URL address'),
    placeholder: gettext('https://www.amazon.com')
  }), store.data.estimated_monthly_tickets !== null && /*#__PURE__*/react.createElement(ui/* Form */.lV.Select, {
    label: gettext('How many returns and warranty claims do you process per month?'),
    placeholder: gettext('How many returns and warranty claims do you process per month?'),
    name: "estimated-ticket-count",
    choices: stores_RegistrationStore.estimatedMonthlyTicketsOptions,
    value: store.data.estimated_monthly_tickets,
    error: (_store$errors3 = store.errors) === null || _store$errors3 === void 0 ? void 0 : _store$errors3.estimated_monthly_tickets,
    onChange: handleUpdateInput('estimated_monthly_tickets'),
    required: true
  }), store.data.estimated_monthly_shipments !== null && /*#__PURE__*/react.createElement(ui/* Form */.lV.Select, {
    label: gettext('How many shipments do you send per month?'),
    placeholder: gettext('How many shipments do you send per month?'),
    name: "estimated-shipment-count",
    choices: stores_RegistrationStore.estimatedMonthlyShipmentsOptions,
    value: store.data.estimated_monthly_shipments,
    error: (_store$errors4 = store.errors) === null || _store$errors4 === void 0 ? void 0 : _store$errors4.estimated_monthly_shipments,
    onChange: handleUpdateInput('estimated_monthly_shipments'),
    required: true
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('We will set up your account in'),
    error: (_store$errors5 = store.errors) === null || _store$errors5 === void 0 ? void 0 : _store$errors5.language
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start gap-6"
  }, stores_RegistrationStore.languageOptions.map(langChoice => /*#__PURE__*/react.createElement(ui/* Form */.lV.Radio, {
    name: "language-".concat(langChoice.value),
    key: langChoice.value,
    label: langChoice.label,
    value: store.data.language === langChoice.value,
    onChange: () => handleUpdateInput('language')(langChoice.value)
  })))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('How did you hear about Retino?')
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col gap-2"
  }, stores_RegistrationStore.retinoDiscoveryOptions.map(option => {
    var _store$errors6;
    return /*#__PURE__*/react.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/react.createElement(ui/* Checkbox */.Sc, {
      id: "discovery-option-".concat(option.value),
      name: "discovery-option-".concat(option.value),
      key: option.value,
      value: store.data.retino_discovery.includes(option.value),
      onChange: () => handleUpdateMultichoiceInput('retino_discovery')(option.value),
      error: (_store$errors6 = store.errors) === null || _store$errors6 === void 0 || (_store$errors6 = _store$errors6.retino_discovery) === null || _store$errors6 === void 0 ? void 0 : _store$errors6.find(item => item === option.value)
    }), /*#__PURE__*/react.createElement("label", {
      htmlFor: "discovery-option-".concat(option.value),
      className: "text-sm text-gray-900"
    }, option.label));
  }))), !isReferralCodeFromUrl && /*#__PURE__*/react.createElement("div", null, !store.data.use_referral_code ? /*#__PURE__*/react.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/react.createElement(ui/* Checkbox */.Sc, {
    id: "use-referral-code",
    name: "use-referral-code",
    key: "use-referral-code",
    value: (_store$data$use_refer = store.data.use_referral_code) !== null && _store$data$use_refer !== void 0 ? _store$data$use_refer : false,
    onChange: () => {
      store.updateData({
        use_referral_code: !store.data.use_referral_code
      });
    }
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: "use-referral-code",
    className: "text-sm text-gray-500"
  }, gettext('I was referred by someone or I have a promotion code'))) : /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    error: (_store$errors7 = store.errors) === null || _store$errors7 === void 0 ? void 0 : _store$errors7.referral_code,
    value: store.data.referral_code,
    name: "referral-code",
    onChange: handleUpdateInput('referral_code'),
    label: gettext('Referral or promotion code'),
    placeholder: "123456-7890-1234-5678-123456789012"
  }))), /*#__PURE__*/react.createElement("div", {
    className: "space-x-4 flex items-center justify-between"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    icon: "arrow-left",
    onClick: store.prevStep,
    secondary: true,
    classNames: classes => [...classes, 'flex-0']
  }), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    submit: true,
    fluid: true,
    primary: true,
    icon: "arrow-right",
    classNames: classes => [...classes, 'flex-1']
  }, gettext('Next')))));
}
/* harmony default export */ const components_CompanyRegistrationStep = ((0,mobxreact_esm/* observer */.PA)(CompanyRegistrationStep));
;// ./react/onboarding/components/ErrorStep.tsx


function ForthStep() {
  return /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    error: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", null, gettext("There was an error and we couldn't process your request.")), /*#__PURE__*/react.createElement("div", null, gettext('Please start from the beginning and try again. If the error prevails, please contact our support and we will help you.')), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start gap-4"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    onClick: () => window.location.reload()
  }, gettext('Try again')), /*#__PURE__*/react.createElement(ui/* Popup */.zD, {
    on: "hover",
    trigger: /*#__PURE__*/react.createElement(ui/* Button */.$n, {
      link: true
    }, /*#__PURE__*/react.createElement("a", {
      href: "mailto:support@retino.com"
    }, gettext('Contact support')))
  }, /*#__PURE__*/react.createElement("span", null, "support@retino.com")))));
}
/* harmony default export */ const ErrorStep = (ForthStep);
;// ./react/onboarding/components/Products.tsx



function ProductSelect(_ref) {
  let {
    onSelect,
    value = []
  } = _ref;
  const isSelected = products => {
    if (!value || !Array.isArray(value)) return false;
    return value.length === products.length && products.every(product => value.includes(product));
  };
  const isBothSelected = isSelected([enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER, enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING]);
  return /*#__PURE__*/react.createElement("div", {
    className: "grid gap-4 grid-cols-1 mt-2"
  }, /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: () => onSelect([enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER, enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING]),
    className: "text-left from-indigo-500 to-orange-500 bg-gradient-to-br rounded-lg p-px cursor-pointer shadow-md hover:scale-[1.02] transition-all duration-300"
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-full rounded-[7px] p-6 select-none transition-all duration-300 ease-in-out relative\n          ".concat(isBothSelected ? 'bg-gradient-to-br from-indigo-500 to-orange-500' : 'bg-white hover:bg-opacity-95')
  }, isBothSelected && /*#__PURE__*/react.createElement("div", {
    className: "absolute right-6 top-6 text-white"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "check",
    size: "small"
  })), /*#__PURE__*/react.createElement("div", {
    className: "font-medium transition-colors duration-300 ".concat(isBothSelected ? 'text-white' : 'text-slate-900')
  }, "Returns + Tracking"), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-sm transition-colors duration-300 ".concat(isBothSelected ? 'text-white/90' : 'text-slate-500')
  }, gettext('Activate both products altogether and provide superior post-purchase customer experience to your customers.')))), /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: () => onSelect([enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER]),
    className: "text-left rounded-lg p-px cursor-pointer shadow-md transition-all duration-200 ".concat(isSelected([enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER]) ? 'bg-indigo-500' : 'bg-gray-300')
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-full bg-white rounded-[7px] p-6 select-none relative"
  }, isSelected([enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER]) && /*#__PURE__*/react.createElement("div", {
    className: "absolute right-6 top-6"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "check",
    size: "small"
  })), /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-slate-900"
  }, "Returns"), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-slate-500 text-sm"
  }, gettext('Manage returns efficiently and increase customer satisfaction.')))), /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: () => onSelect([enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING]),
    className: "text-left rounded-lg p-px cursor-pointer shadow-md transition-all duration-200 ".concat(isSelected([enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING]) ? 'bg-indigo-500' : 'bg-gray-300')
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-full bg-white rounded-[7px] p-6 select-none relative"
  }, isSelected([enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING]) && /*#__PURE__*/react.createElement("div", {
    className: "absolute right-6 top-6"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: "check",
    size: "small"
  })), /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-slate-900"
  }, "Tracking"), /*#__PURE__*/react.createElement("div", {
    className: "mt-1 text-slate-500 text-sm"
  }, gettext('Track shipments seamlessly and keep your customers informed.')))));
}
;// ./react/onboarding/components/ProductSelectStep.tsx







function ProductSelectStep_CompanyRegistrationStep(_ref) {
  var _store$errors;
  let {
    store,
    onSubmit,
    isSubmitting
  } = _ref;
  const handleUpdateInput = fieldName => value => store.updateData({
    [fieldName]: value
  });
  const handleSelectProducts = value => {
    store.updateData({
      selected_products: value
    });
    if (value.includes(enums/* BackendPublicEnums */.C.SelectedProductsEnum.MANAGER)) {
      handleUpdateInput('estimated_monthly_tickets')(22);
    } else {
      handleUpdateInput('estimated_monthly_tickets')(null);
    }
    if (value.includes(enums/* BackendPublicEnums */.C.SelectedProductsEnum.TRACKING)) {
      handleUpdateInput('estimated_monthly_shipments')(24);
    } else {
      handleUpdateInput('estimated_monthly_shipments')(null);
    }
    onSubmit();
  };
  const next = new URLSearchParams(window.location.search).get('next');
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, null, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('Which Retino product(s) would you like to use?'),
    error: (_store$errors = store.errors) === null || _store$errors === void 0 ? void 0 : _store$errors.selected_products
  }, /*#__PURE__*/react.createElement(ProductSelect, {
    onSelect: sp => handleSelectProducts(sp)
  }))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", {
    className: "pt-4 text-sm text-gray-500"
  }, gettext('Already have an account?'), "\xA0", /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: codegen_authRoutes.authLogin({
      lang: window.appState.lang
    }) + (next ? "?next=".concat(next) : ''),
    className: "underline"
  }, gettext('Sign in')))));
}
/* harmony default export */ const ProductSelectStep = ((0,mobxreact_esm/* observer */.PA)(ProductSelectStep_CompanyRegistrationStep));
;// ./react/onboarding/components/UserRegistrationStep.tsx






function UserRegistrationStep(_ref) {
  var _store$errors, _store$errors2, _store$errors3, _store$errors4, _store$errors5;
  let {
    store,
    onSubmit,
    isSubmitting
  } = _ref;
  const [emailUnique, setEmailUnique] = (0,react.useState)(true);
  const emailValidationTimeout = (0,react.useRef)(null);
  const publicApi = (0,public_api/* default */.Ay)();
  const checkEmailAvailability = async email => {
    let isUnique = true;
    try {
      isUnique = Boolean(await publicApi.AuthEmailAvailableApi.retrieve({
        email
      }));
      if (isUnique && store.errors) {
        store.errors.email = undefined;
      }
    } catch (error) {
      if ((0,utils/* isResponse */.S)(error) && error.response.status === 400) {
        store.errors = await (0,utils/* getErrors */.Y)(error);
      }
    }
    setEmailUnique(isUnique);
  };
  const handleEmailChange = value => {
    store.updateData({
      email: value
    });
    if (value.length >= 5) {
      if (emailValidationTimeout.current) clearTimeout(emailValidationTimeout.current);
      emailValidationTimeout.current = setTimeout(() => checkEmailAvailability(value), 300);
    }
  };
  const handleUpdateInput = fieldName => value => store.updateData({
    [fieldName]: value
  });
  return /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: onSubmit,
    "data-track-label": "signup_form"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    autoFocus: true,
    required: true,
    name: "fullname",
    error: (_store$errors = store.errors) === null || _store$errors === void 0 ? void 0 : _store$errors.full_name,
    value: store.data.full_name,
    onChange: handleUpdateInput('full_name'),
    label: gettext('Your name'),
    placeholder: gettext('John Doe')
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    type: "email",
    name: "email",
    id: "id_email",
    label: gettext('Email'),
    error: ((_store$errors2 = store.errors) === null || _store$errors2 === void 0 ? void 0 : _store$errors2.email) || !emailUnique,
    value: store.data.email,
    onChange: handleEmailChange,
    placeholder: gettext('example@gmail.com')
  }), /*#__PURE__*/react.createElement("p", {
    className: "text-red-600"
  }, /*#__PURE__*/react.createElement("small", null, !emailUnique && /*#__PURE__*/react.createElement("div", null, gettext('This email is already used.'), "\xA0", /*#__PURE__*/react.createElement("a", {
    href: codegen_authRoutes.authLogin({
      lang: window.appState.lang
    }),
    style: {
      fontWeight: 'bold',
      textDecoration: 'underline'
    }
  }, gettext('Sign in'))))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    error: (_store$errors3 = store.errors) === null || _store$errors3 === void 0 ? void 0 : _store$errors3.phone_number,
    value: store.data.phone_number,
    name: "phone",
    onChange: handleUpdateInput('phone_number'),
    label: gettext('Phone number'),
    placeholder: gettext('987 654 321')
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "password",
    required: true,
    name: "password",
    error: (_store$errors4 = store.errors) === null || _store$errors4 === void 0 ? void 0 : _store$errors4.password,
    label: gettext('Password'),
    placeholder: gettext('••••••••'),
    value: store.data.password,
    onChange: handleUpdateInput('password')
  }), ((_store$errors5 = store.errors) === null || _store$errors5 === void 0 ? void 0 : _store$errors5.non_field_errors) && /*#__PURE__*/react.createElement(ui/* Message */.QB, {
    error: true
  }, store.errors.non_field_errors), /*#__PURE__*/react.createElement("div", {
    className: "space-x-4 flex items-center justify-between"
  }, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    icon: "arrow-left",
    onClick: store.prevStep,
    secondary: true,
    classNames: classes => [...classes, 'flex-0']
  }), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    submit: true,
    fluid: true,
    primary: true,
    classNames: classes => [...classes, 'flex-1'],
    icon: "check"
  }, gettext('Create account')))));
}
/* harmony default export */ const components_UserRegistrationStep = ((0,mobxreact_esm/* observer */.PA)(UserRegistrationStep));
;// ./react/onboarding/components/withErrorBoundary.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const withErrorBoundary = WrappedComponent => class extends react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    // Report error to sentry
    if (true) {
      window.Sentry.captureException(error);
    }
    this.setState({
      hasError: true
    });
  }
  render() {
    return /*#__PURE__*/react.createElement(WrappedComponent, _extends({}, this.props, {
      hasError: this.state.hasError
    }));
  }
};
/* harmony default export */ const components_withErrorBoundary = (withErrorBoundary);
;// ./react/onboarding/OnboardingRegister.tsx












function OnboardingRegister(_ref) {
  let {
    hasError
  } = _ref;
  const history = (0,hooks/* useHistory */.W6)();
  const api = (0,public_api/* default */.Ay)();
  const [store] = (0,react.useState)(() => new stores_RegistrationStore(api));
  const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    store.loadFromSearch(history.location.search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store]);
  const submit = async () => {
    setIsSubmitting(true);
    const success = await store.submit();
    if (success) {
      store.errors = {};
      const next = new URLSearchParams(history.location.search).get('next');
      if (next) {
        window.location.href = next;
      } else {
        window.location.href = codegen_appRoutes.index();
      }
    } else {
      setIsSubmitting(false);
    }
  };
  return hasError ? /*#__PURE__*/react.createElement(ErrorStep, null) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("h2", {
    className: "mb-8 text-center text-xl font-medium text-gray-900"
  }, gettext('Create your account')), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, /*#__PURE__*/react.createElement(ui/* Dimmer */.Rr, {
    open: isSubmitting
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-center justify-center opacity-100"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(ui/* Loader */.aH, {
    size: "huge"
  })), /*#__PURE__*/react.createElement("p", {
    className: "mt-2 font-medium text-gray-800"
  }, gettext('Please wait while we setup your account...')))), store.step === 'PRODUCT_SELECT' && /*#__PURE__*/react.createElement(ProductSelectStep, {
    store: store,
    onSubmit: store.nextStep,
    isSubmitting: isSubmitting
  }), store.step === 'COMPANY' && /*#__PURE__*/react.createElement(components_CompanyRegistrationStep, {
    store: store,
    onSubmit: store.nextStep,
    isSubmitting: isSubmitting
  }), store.step === 'USER' && /*#__PURE__*/react.createElement(components_UserRegistrationStep, {
    store: store,
    onSubmit: submit,
    isSubmitting: isSubmitting
  })));
}
/* harmony default export */ const onboarding_OnboardingRegister = (components_withErrorBoundary((0,mobxreact_esm/* observer */.PA)(OnboardingRegister)));
;// ./react/onboarding/prestashop/PrestashopForm.tsx
var PrestashopForm_class;



let PrestashopForm = (0,mobxreact_esm/* observer */.PA)(PrestashopForm_class = class PrestashopForm extends react.Component {
  render() {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
      label: gettext('Password'),
      helpText: gettext('At least 8 characters'),
      type: "password",
      error: this.props.platformIntegrationStore.errors.password,
      value: this.props.platformIntegrationStore.data.password,
      onChange: value => {
        this.props.platformIntegrationStore.data.password = value;
      }
    }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
      type: "text",
      label: gettext('Phone number'),
      error: this.props.platformIntegrationStore.errors.phone_number,
      value: this.props.platformIntegrationStore.data.phone_number,
      onChange: value => {
        this.props.platformIntegrationStore.data.phone_number = value;
      }
    }));
  }
}) || PrestashopForm_class;
/* harmony default export */ const prestashop_PrestashopForm = (PrestashopForm);
;// ./react/onboarding/shopify/ShopifyForm.tsx
var ShopifyForm_class;



let ShopifyForm = (0,mobxreact_esm/* observer */.PA)(ShopifyForm_class = class ShopifyForm extends react.Component {
  render() {
    return /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
      type: "password",
      label: gettext('Password'),
      helpText: gettext('At least 8 characters'),
      error: this.props.platformIntegrationStore.errors.password,
      value: this.props.platformIntegrationStore.data.password,
      onChange: value => {
        this.props.platformIntegrationStore.data.password = value;
      }
    });
  }
}) || ShopifyForm_class;
/* harmony default export */ const shopify_ShopifyForm = (ShopifyForm);
;// ./react/onboarding/shoprenter/ShoprenterForm.tsx



function ShoprenterForm(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "your-name",
    label: gettext('Your name'),
    error: platformIntegrationStore.errors.full_name,
    value: platformIntegrationStore.data.full_name,
    onChange: value => {
      platformIntegrationStore.data.full_name = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "email",
    type: "email",
    label: gettext('Your email'),
    error: platformIntegrationStore.errors.email,
    value: platformIntegrationStore.data.email,
    onChange: value => {
      platformIntegrationStore.data.email = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password",
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "your-phone",
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const shoprenter_ShoprenterForm = ((0,mobxreact_esm/* observer */.PA)(ShoprenterForm));
;// ./react/onboarding/shoptet/ShoptetForm.tsx
var ShoptetForm_class;



let ShoptetForm = (0,mobxreact_esm/* observer */.PA)(ShoptetForm_class = class ShoptetForm extends react.Component {
  render() {
    return /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
      type: "password",
      label: gettext('Password'),
      helpText: gettext('At least 8 characters'),
      error: this.props.platformIntegrationStore.errors.password,
      value: this.props.platformIntegrationStore.data.password,
      onChange: value => {
        this.props.platformIntegrationStore.data.password = value;
      }
    });
  }
}) || ShoptetForm_class;
/* harmony default export */ const shoptet_ShoptetForm = (ShoptetForm);
;// ./react/onboarding/shopware_5/Shopware5Form.tsx



function Shopware5Form(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password",
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "phone",
    cornerHint: gettext('optional'),
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const shopware_5_Shopware5Form = ((0,mobxreact_esm/* observer */.PA)(Shopware5Form));
;// ./react/onboarding/shopware_6/Shopware6Form.tsx



function Shopware6Form(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password",
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "phone",
    cornerHint: gettext('optional'),
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const shopware_6_Shopware6Form = ((0,mobxreact_esm/* observer */.PA)(Shopware6Form));
;// ./react/onboarding/stores/PlatformIntegrationStore.ts
var PlatformIntegrationStore_dec, PlatformIntegrationStore_class, PlatformIntegrationStore_descriptor, PlatformIntegrationStore_descriptor2, PlatformIntegrationStore_descriptor3, PlatformIntegrationStore_descriptor4, PlatformIntegrationStore_descriptor5, _descriptor6, _descriptor7;
function PlatformIntegrationStore_initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function PlatformIntegrationStore_applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function PlatformIntegrationStore_initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }



let PlatformIntegrationStore = (PlatformIntegrationStore_dec = mobx_esm/* action */.XI.bound, (PlatformIntegrationStore_class = class PlatformIntegrationStore {
  constructor(publicApi, platformIntegrationId) {
    PlatformIntegrationStore_initializerDefineProperty(this, "platformIntegrationId", PlatformIntegrationStore_descriptor, this);
    PlatformIntegrationStore_initializerDefineProperty(this, "platformIntegrationData", PlatformIntegrationStore_descriptor2, this);
    PlatformIntegrationStore_initializerDefineProperty(this, "data", PlatformIntegrationStore_descriptor3, this);
    PlatformIntegrationStore_initializerDefineProperty(this, "errors", PlatformIntegrationStore_descriptor4, this);
    PlatformIntegrationStore_initializerDefineProperty(this, "isLoaded", PlatformIntegrationStore_descriptor5, this);
    PlatformIntegrationStore_initializerDefineProperty(this, "isSubmitting", _descriptor6, this);
    this.api = void 0;
    PlatformIntegrationStore_initializerDefineProperty(this, "handleSubmit", _descriptor7, this);
    (0,mobx_esm/* makeObservable */.Gn)(this);
    this.api = publicApi;
    this.platformIntegrationId = platformIntegrationId;
  }
  async load() {
    const [platformIntegrationData] = await Promise.all([this.api.OnboardingPlatformIntegrationApi.retrieve({
      id: this.platformIntegrationId
    })]);
    (0,mobx_esm/* runInAction */.h5)((0,mobx_esm/* action */.XI)(() => {
      this.platformIntegrationData = platformIntegrationData;
      this.isLoaded = true;
    }));
  }
  get type() {
    return this.platformIntegrationData.type;
  }
}, (PlatformIntegrationStore_descriptor = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "platformIntegrationId", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), PlatformIntegrationStore_descriptor2 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "platformIntegrationData", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), PlatformIntegrationStore_descriptor3 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "data", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      selected_products: [],
      referral_code: ''
    };
  }
}), PlatformIntegrationStore_descriptor4 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "errors", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), PlatformIntegrationStore_descriptor5 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "isLoaded", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "isSubmitting", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "load", [PlatformIntegrationStore_dec], Object.getOwnPropertyDescriptor(PlatformIntegrationStore_class.prototype, "load"), PlatformIntegrationStore_class.prototype), _descriptor7 = PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "handleSubmit", [mobx_esm/* action */.XI], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async () => {
      this.isSubmitting = true;
      try {
        await this.api.OnboardingPlatformIntegrateApi.create({
          id: this.platformIntegrationId,
          request: this.data
        });
        window.location.assign('/');
      } catch (response) {
        if ((0,utils/* isResponse */.S)(response)) {
          this.errors = await (0,utils/* getErrors */.Y)(response);
        } else {
          toast/* default */.A.error();
        }
        this.isSubmitting = false;
      }
    };
  }
}), PlatformIntegrationStore_applyDecoratedDescriptor(PlatformIntegrationStore_class.prototype, "type", [mobx_esm/* computed */.EW], Object.getOwnPropertyDescriptor(PlatformIntegrationStore_class.prototype, "type"), PlatformIntegrationStore_class.prototype)), PlatformIntegrationStore_class));
/* harmony default export */ const stores_PlatformIntegrationStore = (PlatformIntegrationStore);
;// ./react/onboarding/unas/UnasForm.tsx



function UnasForm(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "your-name",
    label: gettext('Your name'),
    error: platformIntegrationStore.errors.full_name,
    value: platformIntegrationStore.data.full_name,
    onChange: value => {
      platformIntegrationStore.data.full_name = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "email",
    type: "email",
    label: gettext('Your email'),
    error: platformIntegrationStore.errors.email,
    value: platformIntegrationStore.data.email,
    onChange: value => {
      platformIntegrationStore.data.email = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password",
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "your-phone",
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const unas_UnasForm = ((0,mobxreact_esm/* observer */.PA)(UnasForm));
;// ./react/onboarding/upgates/UpgatesForm.tsx



function UpgatesForm(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "your-name",
    label: gettext('Your name'),
    error: platformIntegrationStore.errors.full_name,
    value: platformIntegrationStore.data.full_name,
    onChange: value => {
      platformIntegrationStore.data.full_name = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "email",
    type: "email",
    label: gettext('Your email'),
    error: platformIntegrationStore.errors.email,
    value: platformIntegrationStore.data.email,
    onChange: value => {
      platformIntegrationStore.data.email = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "your-phone",
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const upgates_UpgatesForm = ((0,mobxreact_esm/* observer */.PA)(UpgatesForm));
;// ./react/onboarding/webareal/WebarealForm.tsx



function WebarealForm(_ref) {
  let {
    platformIntegrationStore
  } = _ref;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "company-name",
    label: gettext('Account name'),
    error: platformIntegrationStore.errors.company_name,
    value: platformIntegrationStore.data.company_name,
    onChange: value => {
      platformIntegrationStore.data.company_name = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "full-name",
    label: gettext('Your name'),
    error: platformIntegrationStore.errors.full_name,
    value: platformIntegrationStore.data.full_name,
    onChange: value => {
      platformIntegrationStore.data.full_name = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "email",
    type: "email",
    label: gettext('Your email'),
    error: platformIntegrationStore.errors.email,
    value: platformIntegrationStore.data.email,
    onChange: value => {
      platformIntegrationStore.data.email = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    required: true,
    name: "password",
    type: "password",
    label: gettext('Password'),
    helpText: gettext('At least 8 characters'),
    error: platformIntegrationStore.errors.password,
    value: platformIntegrationStore.data.password,
    onChange: value => {
      platformIntegrationStore.data.password = value;
    }
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    type: "text",
    name: "phone",
    cornerHint: gettext('optional'),
    label: gettext('Phone number'),
    error: platformIntegrationStore.errors.phone_number,
    value: platformIntegrationStore.data.phone_number,
    onChange: value => {
      platformIntegrationStore.data.phone_number = value;
    }
  }));
}
/* harmony default export */ const webareal_WebarealForm = ((0,mobxreact_esm/* observer */.PA)(WebarealForm));
;// ./react/onboarding/PlatformIntegration.tsx


















function PlatformIntegration() {
  var _platformIntegrationS;
  const {
    platformIntegrationId
  } = (0,dist/* useParams */.g)();
  const publicApi = (0,public_api/* default */.Ay)();
  const [platformIntegrationStore] = (0,react.useState)(new stores_PlatformIntegrationStore(publicApi, platformIntegrationId));
  (0,react.useEffect)(() => {
    if (!platformIntegrationStore.isLoaded) platformIntegrationStore.load();
  }, [platformIntegrationStore, platformIntegrationStore.isLoaded]);
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h1", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Finish setting up your account')), /*#__PURE__*/react.createElement("div", {
    style: {
      paddingTop: 20
    }
  }, /*#__PURE__*/react.createElement(ui/* Form */.lV, {
    onSubmit: platformIntegrationStore.handleSubmit
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp, {
    loading: !platformIntegrationStore.isLoaded || platformIntegrationStore.isSubmitting
  }, /*#__PURE__*/react.createElement(ui/* Card */.Zp.Content, null, platformIntegrationStore.isLoaded && /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, platformIntegrationStore.type === 'SHOPTET_API' && /*#__PURE__*/react.createElement(shoptet_ShoptetForm, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'SHOPRENTER_API' && /*#__PURE__*/react.createElement(shoprenter_ShoprenterForm, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'PRESTASHOP_16' && /*#__PURE__*/react.createElement(prestashop_PrestashopForm, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'SHOPIFY_API' && /*#__PURE__*/react.createElement(shopify_ShopifyForm, {
    platformIntegrationStore: platformIntegrationStore
  }), ['WEBAREAL_API'].includes(platformIntegrationStore.type) && /*#__PURE__*/react.createElement(webareal_WebarealForm, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'SHOPWARE_6' && /*#__PURE__*/react.createElement(shopware_6_Shopware6Form, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'SHOPWARE_5' && /*#__PURE__*/react.createElement(shopware_5_Shopware5Form, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'UPGATES_API' && /*#__PURE__*/react.createElement(upgates_UpgatesForm, {
    platformIntegrationStore: platformIntegrationStore
  }), platformIntegrationStore.type === 'UNAS_API' && /*#__PURE__*/react.createElement(unas_UnasForm, {
    platformIntegrationStore: platformIntegrationStore
  }), /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    label: gettext('Which Retino product(s) would you like to use?'),
    error: (_platformIntegrationS = platformIntegrationStore.errors) === null || _platformIntegrationS === void 0 ? void 0 : _platformIntegrationS.selected_products
  }, /*#__PURE__*/react.createElement("div", {
    className: "grid gap-4 grid-cols-1 mt-2"
  }, /*#__PURE__*/react.createElement(ProductSelect, {
    onSelect: selectedProducts => {
      platformIntegrationStore.data.selected_products = selectedProducts;
    },
    value: platformIntegrationStore.data.selected_products
  }))), /*#__PURE__*/react.createElement(ui/* Form */.lV.Input, {
    label: gettext('Referral or promotion code'),
    error: platformIntegrationStore.errors.referral_code,
    value: platformIntegrationStore.data.referral_code,
    onChange: value => {
      platformIntegrationStore.data.referral_code = value;
    }
  }), 'other' in platformIntegrationStore.errors && /*#__PURE__*/react.createElement("div", {
    className: "text-red-500 text-sm"
  }, platformIntegrationStore.errors.other), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, gettext("About once a month, we send a newsletter with all the hot updates that we have shipped. We will never spam you. Anytime one-click unsubscribe, if you don't like it.")), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    fluid: true,
    submit: true,
    primary: true,
    loading: platformIntegrationStore.isSubmitting
  }, gettext('Create your account')), /*#__PURE__*/react.createElement("div", {
    className: "text-sm text-gray-500"
  }, gettext('Already have an account?'), "\xA0", /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    link: true
  }, /*#__PURE__*/react.createElement(react_router_dom_dist/* Link */.N_, {
    to: "".concat(codegen_authRoutes.authLogin({
      lang: window.appState.lang
    }), "?next=").concat(codegen_appRoutes.onboardingPlatformIntegrationPlatformIntegrationIdConnectAccount({
      platformIntegrationId: platformIntegrationStore.platformIntegrationId
    }))
  }, gettext('Sign in')))), /*#__PURE__*/react.createElement("div", {
    className: "text-xs text-gray-500"
  }, /*#__PURE__*/react.createElement("div", null, gettext('By clicking the button, you agree to our')), /*#__PURE__*/react.createElement("ul", {
    className: "list-inside list-disc"
  }, /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    link: true,
    size: "tiny"
  }, /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com/obchodni-podminky/",
    className: "text-xs"
  }, gettext('Terms of Service')))), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    link: true,
    size: "tiny"
  }, /*#__PURE__*/react.createElement("a", {
    href: "https://www.retino.com/ochrana-osobnich-udaju/",
    className: "text-xs"
  }, gettext('Privacy Policy'))))))))))));
}
/* harmony default export */ const onboarding_PlatformIntegration = ((0,mobxreact_esm/* observer */.PA)(PlatformIntegration));
;// ./react/onboarding/PlatformIntegrationCompleted.tsx


function PlatformIntegrationCompleted() {
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h1", {
    className: "text-center text-xl font-medium text-gray-900"
  }, gettext('Integration completed'))), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, /*#__PURE__*/react.createElement("p", {
    className: "mb-4"
  }, gettext('Your account is already integrated. Click the link below to proceed to your dashboard.')), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    primary: true,
    onClick: () => window.location.assign('/')
  }, gettext('Dashboard'))), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true
  }, gettext('If you encounter any problems, please do not hesitate to contact our support at'), "\xA0", /*#__PURE__*/react.createElement("a", {
    className: "text-indigo-600",
    href: "mailto:support@retino.com"
  }, "support@retino.com")));
}
/* harmony default export */ const onboarding_PlatformIntegrationCompleted = (PlatformIntegrationCompleted);
;// ./react/onboarding/shoptet/ShoptetPlatformIntegrationEmail.tsx





function ShoptetPlatformIntegrationEmail() {
  const {
    platformIntegrationId
  } = (0,dist/* useParams */.g)();
  const [platformIntegrationEmail, setPlatformIntegrationEmail] = (0,react.useState)(null);
  const api = (0,public_api/* default */.Ay)();
  const load = async () => {
    const response = await api.OnboardingShoptetPlatformIntegrationEmailApi.retrieve({
      id: platformIntegrationId
    });
    setPlatformIntegrationEmail(response.email);
  };
  const [handleLoad] = (0,hooks/* useAsyncFunction */.m_)(load);
  (0,react.useEffect)(() => {
    handleLoad();
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/react.createElement("h1", {
    className: "text-xl font-medium"
  }, gettext('Pending integration')), /*#__PURE__*/react.createElement("p", null, gettext('You have successfully installed your Shoptet add-on. Now you need to create Retino account. We have sent you instructions to the email address below.')), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, {
    padded: true,
    textAlign: "center"
  }, /*#__PURE__*/react.createElement("strong", null, platformIntegrationEmail), "\xA0"), /*#__PURE__*/react.createElement(ui/* Segment */.Y4, null, gettext('If you encounter any problems, please do not hesitate to contact our support at'), "\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:support@retino.com"
  }, "support@retino.com")));
}
/* harmony default export */ const shoptet_ShoptetPlatformIntegrationEmail = (ShoptetPlatformIntegrationEmail);
;// ./react/auth_index.tsx
/* eslint-disable max-len */



















class Retino extends react.Component {
  componentDidCatch(error, errorInfo) {
    window.Sentry.captureException(error, {
      extra: errorInfo
    });
  }
  render() {
    return /*#__PURE__*/react.createElement(errorBoundaries/* ErrorBoundary */.t, null, /*#__PURE__*/react.createElement(contexts_AuthContextProviders, null, /*#__PURE__*/react.createElement(ScrollToTop/* default */.A, null), /*#__PURE__*/react.createElement(dist/* Routes */.BV, null, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      element: /*#__PURE__*/react.createElement(layouts_AuthLayout, null, /*#__PURE__*/react.createElement(dist/* Outlet */.sv, null))
    }, /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.onboarding.url,
      element: /*#__PURE__*/react.createElement(onboarding_OnboardingRegister, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.authLogin.url,
      element: /*#__PURE__*/react.createElement(auth_Login, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.authPasswordReset.url,
      element: /*#__PURE__*/react.createElement(auth_PasswordReset, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.authResetUidb64Token.url,
      element: /*#__PURE__*/react.createElement(auth_PasswordSet, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.onboardingShoptetDisplayEmailPlatformIntegrationDetail.url,
      element: /*#__PURE__*/react.createElement(shoptet_ShoptetPlatformIntegrationEmail, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.onboardingPlatformIntegrationPlatformIntegrationDetail.url,
      element: /*#__PURE__*/react.createElement(onboarding_PlatformIntegration, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.onboardingPlatformIntegrationPlatformIntegrationIdCompleted.url,
      element: /*#__PURE__*/react.createElement(onboarding_PlatformIntegrationCompleted, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.companyInvitationExpired.url,
      element: /*#__PURE__*/react.createElement(auth_InvitationExpired, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.companyInvitationAcceptInvitationDetail.url,
      element: /*#__PURE__*/react.createElement(auth_Invitation, null)
    }), /*#__PURE__*/react.createElement(dist/* Route */.qh, {
      path: codegen_authRoutes.companyLaunchpad.url,
      element: /*#__PURE__*/react.createElement(components_Launchpad, null)
    }))), /*#__PURE__*/react.createElement(ui/* ToastContainer */.N9, null)));
  }
}
const container = document.getElementById('react-root');
const root = (0,client/* createRoot */.H)(container);
root.render( /*#__PURE__*/react.createElement(react_router_dom_dist/* BrowserRouter */.Kd, null, /*#__PURE__*/react.createElement(Retino, null)));
;// ./assets/auth_bundle.jsx
/* provided dependency */ var moment = __webpack_require__(95093);
/*
 *   This will build into .js and .css files that can be rendered:
 *
 *   include:    {% load render_bundle from webpack_loader %}
 *   head:       {% render_bundle 'client_bundle' 'css' %}
 *   footer:     {% render_bundle 'client_bundle' 'js' %}
 */










/* react app */


(0,mobx_esm/* configure */.jK)({
  enforceActions: 'never',
});

if (true) {
  sdk/* init */.T({
    dsn: 'https://b66899ef04f24590954284699e871c64@sentry.io/1223003',
    environment: "production",
    release: 'could-not-get-sha',
    denyUrls: blacklisted_urls/* default */.A,
    ignoreErrors: blacklisted_errors/* default */.A,
  });

  const scope = esm_exports/* getCurrentScope */.o5();
  scope.setTag('bundle', 'Auth');
  scope.setExtra('appState', window.appState);

  window.Sentry = esm;
} else {}

moment.locale(window.appState.lang);


/***/ }),

/***/ 41906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Lr: () => (/* binding */ parseUrlSearch),
/* harmony export */   Rg: () => (/* binding */ isFrontendOutdated),
/* harmony export */   aS: () => (/* binding */ currentLanguage),
/* harmony export */   g6: () => (/* binding */ toggleItem),
/* harmony export */   hW: () => (/* binding */ nl2p),
/* harmony export */   qr: () => (/* binding */ useContextSafe),
/* harmony export */   rs: () => (/* binding */ parsedUrlSearchArrayValuesToSingleValues),
/* harmony export */   yl: () => (/* binding */ conatinsHTMLTags)
/* harmony export */ });
/* unused harmony exports rgetattr, assert, currencyDisplay, useI18nToStr, arrayMove, changeCollection, convertDecimal, formatPrice, nl2br, usePrevValue, isProductionEnvironment, useRerender, getForegroundColor, isUUID, roundHalfUp, indexArrayByProp, useAsyncEffect, formatDateAsMomentCalendar, weekDays, monthNames, getNextNDays, compareObjects, compareQueries, makeAbsoluteUrl, isUrlValid, isImage, excerpt, formatNumber, getOrderPortalDirectLink, useStoreUrlConnect, toUrlSearchString, convertHeicToJpeg, loadScript, LocalStorageCache */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var contexts_CurrentLanguageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60758);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9432);
/* harmony import */ var stores_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25193);
/* provided dependency */ var moment = __webpack_require__(95093);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








/**
 * Get nested attribute from object
 * rgetattr(obj, 'test.attr1') == obj.test.attr1
 * @param {object} obj
 * @param {string} attrName
 * @param {string} separator
 */
const rgetattr = function (obj, attrName) {
  let separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  const attrList = attrName.split(separator);
  let value = obj && obj[attrList[0]];
  for (let i = 1; i < attrList.length; ++i) value = value && value[attrList[i]];
  return value;
};
function assert(condition) {
  let msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion Error';
  if (!condition) {
    throw new Error(msg);
  }
}
const currencyDisplay = currencyISO => stores_constants__WEBPACK_IMPORTED_MODULE_4__/* .allCurrenciesSymbol */ .pH[currencyISO] || currencyISO;
const currentLanguage = (i18nObject, lang) => {
  if (i18nObject === null || i18nObject === undefined) return '';
  if (typeof i18nObject === 'string') {
    return i18nObject;
  }

  // Helper function to get value with fallback to base language
  const getLangWithFallback = langCode => {
    const value = i18nObject[langCode];
    if (value) return value;

    // Try base language if regional variant (e.g., 'de-at' -> 'de')
    if (langCode.includes('-')) {
      const baseLang = langCode.split('-')[0];
      return i18nObject[baseLang];
    }
    return undefined;
  };

  // Try provided lang parameter first
  if (lang) {
    const value = getLangWithFallback(lang);
    if (value) return value;
  }

  // Try window.appState.lang
  const appLang = window.appState.lang;
  const appValue = getLangWithFallback(appLang);
  if (appValue) return appValue;

  // Finally, fallback to first truthy value
  return Object.values(i18nObject).find(a => !!a) || '';
};
const useI18nToStr = () => {
  const lang = useCurrentLanguage();
  return i18nObject => currentLanguage(i18nObject, lang) || '';
};
const arrayMove = (items, oldIndex, newIndex) => {
  const copiedItems = [...items]; // shallow copy
  const [tmp] = copiedItems.splice(oldIndex, 1);
  copiedItems.splice(newIndex, 0, tmp);
  return copiedItems;
};
function changeCollection(col1, col2, oldIndex, newIndex) {
  const copyCol1 = [...col1]; // shallow copy
  const copyCol2 = [...col2]; // shallow copy
  const [tmp] = copyCol1.splice(oldIndex, 1); // remove from old collection
  copyCol2.splice(newIndex, 0, tmp); // insert to new
  return [copyCol1, copyCol2];
}
const convertDecimal = (price, currency) => Number(price) / 100;
const formatPrice = function (price, currency) {
  let isDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isDecimal) price = convertDecimal(price, currency);
  try {
    const fractionDigits = price % 1 === 0 ? 0 : undefined;
    const langCode = window.appState.lang;
    const priceFormatter = Intl.NumberFormat(langCode, {
      style: 'currency',
      currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
    return priceFormatter.format(price);
  } catch (error) {
    console.error(error);
    return "".concat(price, " ").concat(currency);
  }
};
function nl2br(str) {
  str = str || '';
  const newlineRegex = /(\r\n|\r|\n)/g;
  if (typeof str === 'number') {
    return str;
  }
  if (typeof str !== 'string') {
    return '';
  }
  return str.split(newlineRegex).map((line, index) => {
    if (line.match(newlineRegex)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement('br', {
        key: index
      });
    }
    return line;
  });
}
function nl2p(str) {
  return str.split('\n').map(item => "<p>".concat(item, "</p>")).join('');
}
const usePrevValue = props => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = props;
  });
  return ref.current;
};
const isProductionEnvironment = () => "production" === 'production';
const useRerender = () => {
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(v => !v), []);
  return rerender;
};
const getForegroundColor = backgroundColor => {
  /* This will be black or white - the one that will be more suitable for selected background color */
  const darkColor = '#000000';
  const lightColor = '#ffffff';

  // creates array ["RR", "GG", "BB"]
  const parsedColor = backgroundColor.slice(1).match(/.{2}/g);
  if (parsedColor === null || parsedColor.length !== 3) return darkColor;

  // applies this magic formula 'if (red*0.299 + green*0.587 + blue*0.114) > 186 use #000000 else use #ffffff'
  const backgroundColorIntensivness = parsedColor.map(x => parseInt(x, 16)).reduce((acc, curr, i) => acc + curr * [0.299, 0.587, 0.114][i], 0);
  return backgroundColorIntensivness > 150 ? darkColor : lightColor;
};
const isUUID = str => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
const roundHalfUp = (value, decimals) => {
  const decimal = Math.round(Number("".concat(value, "e").concat(decimals)));
  return Number("".concat(decimal, "e-").concat(decimals));
};
function useContextSafe(context) {
  const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
  if (value === null || value === undefined) {
    throw Error("Context ".concat(context, " must be used within context provider!"));
  }
  return value;
}
const indexArrayByProp = (array, prop) => array.reduce((acc, curr) => {
  acc[curr[prop]] = curr;
  return acc;
}, {});
const useAsyncEffect = (func, deps) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
  func();
}, deps);
const formatDateAsMomentCalendar = date => moment(date).calendar(null, {
  sameDay: "[".concat(gettext('Today'), "]"),
  nextDay: "[".concat(gettext('Tomorrow'), "]"),
  nextWeek: 'LL',
  lastDay: "[".concat(gettext('Yesterday'), "]"),
  lastWeek: 'LL',
  sameElse: 'LL'
});
const weekDays = [gettext('Monday'), gettext('Tuesday'), gettext('Wednesday'), gettext('Thursday'), gettext('Friday'), gettext('Saturday'), gettext('Sunday')];
const monthNames = [gettext('January'), gettext('February'), gettext('March'), gettext('April'), gettext('May'), gettext('June'), gettext('July'), gettext('August'), gettext('September'), gettext('October'), gettext('November'), gettext('December')];
const getNextNDays = count => {
  const today = new Date();
  const addDays = days => {
    const d = new Date(today.valueOf());
    d.setDate(d.getDate() + days);
    return d;
  };
  const getDayIndex = offset => (offset + today.getDay()) % 7;
  const getDayName = offset => "".concat(getDayIndex(offset) === today.getDay() ? gettext('Tomorrow') : weekDays[getDayIndex(offset)], ", ").concat(moment(addDays(offset + 1)).format('D. M.'));
  return [...Array(count).keys()].map(i => [getDayIndex(i), getDayName(i)]);
};
function compareObjects(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return isEqual(omit(q1, excludeFields), omit(q2, excludeFields));
}
function compareQueries(q1, q2) {
  let excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return compareObjects(q1, q2, [...excludeFields, 'page', 'search']);
}
function toggleItem(list, updatedElement) {
  if (!list) {
    return [updatedElement];
  }
  return list.includes(updatedElement) ? list.filter(item => item !== updatedElement) : [...list, updatedElement];
}
function makeAbsoluteUrl(url) {
  if (url) {
    const defaultProtocol = 'https';
    if (!url.match(/^(https?:)?\/\//)) {
      return "".concat(defaultProtocol, "://").concat(url);
    }
  }
  return url;
}
function isUrlValid(url) {
  const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm;
  return urlRegex.test(url);
}
function isImage(filename) {
  if (filename === undefined || filename === null) return false;
  return filename.match(/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/);
}
const excerpt = (s, len) => s.length > len ? "".concat(s.substr(0, len - 3), "...") : s;
const formatNumber = n => new Intl.NumberFormat(window.appState.lang).format(n);
function getOrderPortalDirectLink(companyId, email, orderCode, lang) {
  return "".concat(window.location.origin, "/").concat(lang, "/order-tracking/").concat(companyId, "/direct-link/?email=").concat(email, "&code=").concat(orderCode);
}
function useStoreUrlConnect(store) {
  const isMounted = useRef(true);
  const history = useHistory();
  const [, setSearchParams] = useSearchParams();
  const loadUrlQuery = () => store.loadFromURLQuery(history.location.search);
  const setUrlQuery = () => {
    if (!isMounted.current || !store.isLoaded) return;
    setSearchParams(store.urlQuery);
  };
  const load = async () => {
    if (!isMounted.current) return;
    await loadUrlQuery();
    setUrlQuery();
  };
  useEffect(() => {
    load();
    const disposer = autorun(() => {
      setUrlQuery();
    });
    isMounted.current = true;
    return () => {
      disposer();
      isMounted.current = false;
    };
  }, []);
}
function parseUrlSearch(search) {
  if (!search) {
    return {};
  }

  // Parse url search string into object. Each key has an array of values (even single values are in array).
  const searchParams = new URLSearchParams(search);
  const result = {};
  searchParams.forEach((value, key) => {
    if (!(key in result)) {
      result[key] = [];
    }
    try {
      result[key].push(JSON.parse(value));
    } catch (e) {
      result[key].push(value);
    }
  });
  return result;
}
function parsedUrlSearchArrayValuesToSingleValues(parsedUrlSearch) {
  // e.g. {'is_valid': [true], 'another_key': [7], 'key': [2, 6, 7]} -> {'is_valid': true, 'another_key': 7, 'key': [2, 6, 7]}
  return Object.entries(parsedUrlSearch).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return Array.isArray(value) && value.length === 1 ? _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value[0]
    }) : _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value
    });
  }, {});
}
function toUrlSearchString(queryObj) {
  if (!queryObj || Object.keys(queryObj).length === 0) {
    return '';
  }
  const searchParams = new URLSearchParams();
  Object.entries(queryObj).forEach(_ref2 => {
    let [key, value] = _ref2;
    return value !== undefined && (Array.isArray(value) ? value.forEach(val => searchParams.append(key, val)) : searchParams.append(key, value));
  });
  return searchParams.toString();
}
function isFrontendOutdated() {
  return window.appState.bundleHash !== window.appState.latestBundleHash;
}
function conatinsHTMLTags(str) {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}
const convertHeicToJpeg = async file => {
  /**
   * Converts a HEIC image file to a JPEG format.
   *
   * @param {File} file - The HEIC file to be converted.
   *
   * @returns {Promise<File>} - A Promise that resolves to the converted JPEG file.
   *
   * @description
   * This function takes a HEIC file as input, uses a web worker and an external library (libheif)
   * to process and convert the HEIC file to JPEG format. The conversion is done asynchronously,
   * and the resulting JPEG file is returned in a Promise. The function also handles error reporting
   * through Sentry in case of conversion or worker errors.
   *
   * - It creates a temporary URL for the input file.
   * - It communicates with a web worker responsible for performing the conversion using the HEIF library.
   * - The converted file's name is derived from the original HEIC file but with a ".jpeg" extension.
   * - Any errors during conversion are captured by Sentry and propagated to the caller via rejection.
   * - The temporary URL is revoked after the conversion is complete.
   */

  const workerScriptUrl = "".concat(window.appState.baseStaticUrl, "heicToJpgConvertor.js");
  const libHeifUrl = "".concat(window.appState.baseStaticUrl, "libheif-bundle.js");
  const workerScriptContent = await (await fetch(workerScriptUrl)).blob();
  const url = URL.createObjectURL(workerScriptContent);

  // this needs to be a data/blob URL because Workers need to be served from the same origin as the main thread
  // therefore we cannot load the worker script from a different origin (e.g. cdn)
  // See https://developer.mozilla.org/en-US/docs/Web/API/Worker/Worker#security_considerations
  // and https://stackoverflow.com/questions/21913673/execute-web-worker-from-different-origin
  const worker = new Worker(url);
  const convertedFile = await new Promise((resolve, reject) => {
    const imageBlob = new Blob([file], {
      type: 'image/heic'
    });
    worker.postMessage({
      file: imageBlob,
      libHeifUrl
    });
    worker.onmessage = e => {
      if (e.data.error) {
        window.Sentry.captureException(new Error(e.data.error));
        reject(new Error(e.data.error));
      } else if (e.data.blob) {
        const name = file.name.replace(/\.heic$/i, '.jpeg');
        resolve(new File([e.data.blob], name, {
          type: 'image/jpeg'
        }));
      }
    };
    worker.onerror = err => {
      window.Sentry.captureException(err);
      reject(err);
    };
  });
  worker.terminate();
  URL.revokeObjectURL(url);
  return convertedFile;
};
const loadScript = (() => {
  // Cache for storing ongoing load promises
  const scriptPromises = {};
  return (src, id) => {
    // If a script load has already been initiated, return the same promise
    if (scriptPromises[id]) {
      return scriptPromises[id];
    }
    scriptPromises[id] = new Promise((resolve, reject) => {
      const scriptElement = document.getElementById(id);
      if (!scriptElement) {
        // Create the script element if it doesn't exist
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        const handleLoadScriptSuccess = () => {
          script.setAttribute('loaded', 'true'); // Mark as loaded
          resolve({
            successful: true
          });
          delete scriptPromises[id]; // Clean up cache
        };
        const handleLoadScriptFail = event => {
          reject(new Error(event.toString()));
          delete scriptPromises[id]; // Clean up cache
        };
        script.addEventListener('load', handleLoadScriptSuccess, {
          once: true
        });
        script.addEventListener('error', handleLoadScriptFail, {
          once: true
        });
        document.head.appendChild(script);
      } else if (scriptElement.getAttribute('loaded') === 'true') {
        // If the script is already loaded
        resolve({
          successful: true
        });
      } else {
        // Script is not yet loaded, wait for it to finish loading
        scriptElement.addEventListener('load', () => resolve({
          successful: true
        }), {
          once: true
        });
        scriptElement.addEventListener('error', event => reject(new Error(event.toString())), {
          once: true
        });
      }
    });
    return scriptPromises[id];
  };
})();

/**
 * A cache interface for storing and retrieving data with timestamps
 */

/**
 * LocalStorageCache provides a convenient way to cache data in localStorage with
 * automatic expiration handling.
 */
class LocalStorageCache {
  /**
   * Create a new LocalStorageCache instance
   *
   * @param key - The specific key for this cache instance
   * @param prefix - The prefix for the localStorage key
   * @param timeoutSec - Timeout in seconds (default: 7 days)
   */
  constructor(key) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LOCAL_STORAGE_CACHE';
    let timeoutSec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7 * 24 * 60 * 60;
    this.cacheKey = void 0;
    this.prefix = void 0;
    this.key = void 0;
    this.timeoutMs = void 0;
    this.prefix = prefix;
    this.key = key;
    this.timeoutMs = timeoutSec * 1000;
    this.cacheKey = "".concat(this.prefix, "_").concat(this.key);
  }

  /**
   * Store data in the cache
   *
   * @param data - The data to cache
   * @param isRetry - Whether this is a retry attempt after clearing space
   * @returns void
   */
  save(data) {
    let isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const cachedData = {
      timestamp: Date.now(),
      data
    };
    try {
      localStorage.setItem(this.cacheKey, JSON.stringify(cachedData));
    } catch (error) {
      // Check if it's a quota exceeded error using MDN-specified identifiers
      // https://developer.mozilla.org/en-US/docs/Web/API/Storage_API/Storage_quotas_and_eviction_criteria#web_storage
      if (!isRetry && error instanceof DOMException && (
      // Standard
      error.name === 'QuotaExceededError' || error.code === DOMException.QUOTA_EXCEEDED_ERR ||
      // Firefox
      error.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
      // Safari/WebKit
      error.name === 'QUOTA_EXCEEDED_ERR')) {
        // Clear old caches with the same prefix
        if (this.prefix) {
          this.clearCachesWithPrefix();
        } else {
          this.clear();
        }
        // Try again with isRetry flag to prevent infinite recursion
        this.save(data, true);
      } else if (window.Sentry) {
        // Either it's already a retry attempt or it's a different error
        window.Sentry.captureException(error);
      }
    }
  }

  /**
   * Load data from the cache if it exists and is not expired
   *
   * @returns The cached data or null if no valid cache exists
   */
  load() {
    const cachedDataString = localStorage.getItem(this.cacheKey);
    if (cachedDataString) {
      try {
        const cachedData = JSON.parse(cachedDataString);
        const currentTime = Date.now();

        // Check if cache is still valid (less than timeout)
        if (cachedData.timestamp && currentTime - cachedData.timestamp < this.timeoutMs) {
          return cachedData.data;
        }
      } catch (error) {
        if (window.Sentry) {
          window.Sentry.captureException(error);
        }
      }

      // Cache is expired or invalid, remove it
      localStorage.removeItem(this.cacheKey);
    }
    return null;
  }

  /**
   * Check if there is valid data in the cache
   *
   * @returns boolean indicating if valid cache exists
   */
  hasValidCache() {
    return this.load() !== null;
  }

  /**
   * Remove this cache entry
   */
  clear() {
    localStorage.removeItem(this.cacheKey);
  }

  /**
   * Clear all caches with the given prefix
   *
   * @param prefix - The prefix to match for clearing caches
   */
  clearCachesWithPrefix() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.prefix)) {
        keysToRemove.push(key);
      }
    }

    // Remove the collected keys
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  arrayMove,
  assert,
  conatinsHTMLTags,
  convertHeicToJpeg,
  currencyDisplay,
  currentLanguage,
  excerpt,
  formatDateAsMomentCalendar,
  formatPrice,
  getForegroundColor,
  getOrderPortalDirectLink,
  indexArrayByProp,
  isFrontendOutdated,
  isImage,
  isUrlValid,
  loadScript,
  LocalStorageCache,
  makeAbsoluteUrl,
  monthNames,
  nl2br,
  nl2p,
  parseUrlSearch,
  rgetattr,
  roundHalfUp,
  toUrlSearchString,
  useAsyncEffect,
  usePrevValue,
  useRerender,
  weekDays
});

/***/ }),

/***/ 25193:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P8: () => (/* binding */ allLanguagesLocalised),
/* harmony export */   Uv: () => (/* binding */ supportedLanguages),
/* harmony export */   pH: () => (/* binding */ allCurrenciesSymbol)
/* harmony export */ });
/* unused harmony exports ONBOARDING_SAMPLE_ORDER_CODE, flags, historyItemTypes, notificationTypes, allCountries, allLanguages, countryCodeToCountryName, allCurrenciesName */
const ONBOARDING_SAMPLE_ORDER_CODE = 'TUTORIAL-0001';
const flags = {
  FLAG_CREATED_BY_SHOPTET: 'created_by_shoptet',
  FLAG_SHOPTET_API_IMPORT_ORDERS: 'shoptet_api_import_orders',
  FLAG_IS_DISABLED: 'is_disabled',
  FLAG_IS_RETINO_SALES: 'is_retino_sales',
  FLAG_IS_RETINO_ADMIN: 'is_retino_admin',
  FLAG_ENABLE_KEYBOARD_SHORTCUTS: 'enable_keyboard_shortcuts',
  FLAG_DISPLAY_TRANSPORT_SETTINGS: 'display_doprava_settings',
  FLAG_DISPLAY_API_SETTINGS: 'display_api_settings',
  FLAG_DISPLAY_BADGE_SETTINGS: 'display_odznak_settings',
  FLAG_DISPLAY_BILLING_SETTINGS: 'display_billing_settings',
  FLAG_SAMPLE_TICKET: 'sample_ticket'
};
const historyItemTypes = {
  MESSAGE: 'MESSAGE',
  SYSTEM: 'SYSTEM',
  DOCUMENT: 'DOCUMENT',
  TRANSPORT: 'TRANSPORT',
  SHIPPING_REQUEST: 'SHIPPING_REQUEST',
  INTERNAL_NOTE: 'INTERNAL_NOTE',
  RATING_COMMENT: 'RATING_COMMENT',
  REFUND_REQUEST: 'REFUND_REQUEST',
  ACTIVITY: 'ACTIVITY'
};
const notificationTypes = {
  TICKET_MESSAGE_ADDED_BY_CUSTOMER: 'TICKET_MESSAGE_ADDED_BY_CUSTOMER',
  TICKET_MESSAGE_UNDELIVERED: 'TICKET_MESSAGE_UNDELIVERED',
  TICKET_CREATED_BY_CUSTOMER: 'TICKET_CREATED_BY_CUSTOMER',
  TICKET_UPCOMING_DATE: 'TICKET_UPCOMING_DATE',
  TICKET_ASSIGNED: 'TICKET_ASSIGNED',
  TICKET_RATED: 'TICKET_RATED'
};
const allCountries = {
  AU: gettext('Australia'),
  AT: gettext('Austria'),
  BY: gettext('Belarus'),
  BE: gettext('Belgium'),
  BA: gettext('Bosnia and Herzegovina'),
  BG: gettext('Bulgaria'),
  CA: gettext('Canada'),
  HR: gettext('Croatia'),
  CY: gettext('Cyprus'),
  CZ: gettext('Czechia'),
  DK: gettext('Denmark'),
  EE: gettext('Estonia'),
  FI: gettext('Finland'),
  FR: gettext('France'),
  DE: gettext('Germany'),
  GR: gettext('Greece'),
  GL: gettext('Greenland'),
  HU: gettext('Hungary'),
  IS: gettext('Iceland'),
  IN: gettext('India'),
  IE: gettext('Ireland'),
  IT: gettext('Italy'),
  LV: gettext('Latvia'),
  LI: gettext('Liechtenstein'),
  LT: gettext('Lithuania'),
  LU: gettext('Luxembourg'),
  MK: gettext('Macedonia'),
  MT: gettext('Malta'),
  MD: gettext('Moldova'),
  MC: gettext('Monaco'),
  ME: gettext('Montenegro'),
  NL: gettext('Netherlands'),
  NO: gettext('Norway'),
  PL: gettext('Poland'),
  PT: gettext('Portugal'),
  QA: gettext('Qatar'),
  RO: gettext('Romania'),
  RU: gettext('Russian Federation'),
  SA: gettext('Saudi Arabia'),
  RS: gettext('Serbia'),
  SK: gettext('Slovakia'),
  SI: gettext('Slovenia'),
  ZA: gettext('South Africa'),
  ES: gettext('Spain'),
  SE: gettext('Sweden'),
  CH: gettext('Switzerland'),
  TW: gettext('Taiwan (Province of China)'),
  TR: gettext('Turkey'),
  UA: gettext('Ukraine'),
  AE: gettext('United Arab Emirates'),
  GB: gettext('United Kingdom of Great Britain and Northern Ireland'),
  US: gettext('United States of America'),
  VN: gettext('Viet Nam')
};
const allLanguages = {
  en: gettext('English'),
  de: gettext('German'),
  'de-at': gettext('German (Austria)'),
  'de-ch': gettext('German (Switzerland)'),
  cs: gettext('Czech'),
  sk: gettext('Slovak'),
  pl: gettext('Polish'),
  hu: gettext('Hungarian'),
  ro: gettext('Romanian'),
  es: gettext('Spanish'),
  it: gettext('Italian'),
  'it-ch': gettext('Italian (Switzerland)'),
  fr: gettext('French'),
  'fr-ch': gettext('French (Switzerland)'),
  'fr-be': gettext('French (Belgium)'),
  hr: gettext('Croatian'),
  bg: gettext('Bulgarian'),
  sl: gettext('Slovenian'),
  el: gettext('Greek'),
  nl: gettext('Dutch'),
  'nl-be': gettext('Dutch (Belgium)'),
  nb: gettext('Norwegian'),
  lv: gettext('Latvian'),
  lt: gettext('Lithuanian'),
  et: gettext('Estonian'),
  da: gettext('Danish'),
  sv: gettext('Swedish'),
  fi: gettext('Finnish'),
  pt: gettext('Portuguese'),
  uk: gettext('Ukrainian')
};
const allLanguagesLocalised = {
  en: 'English',
  de: 'Deutsch',
  'de-at': 'Deutsch (Österreich)',
  'de-ch': 'Deutsch (Schweiz)',
  cs: 'Česky',
  sk: 'Slovenčina',
  pl: 'Polski',
  hu: 'Magyar',
  ro: 'Română',
  es: 'Espanol',
  it: 'Italiano',
  'it-ch': 'Italiano (Svizzera)',
  fr: 'Français',
  'fr-ch': 'Français (Suisse)',
  'fr-be': 'Français (Belgique)',
  nb: 'Norsk',
  hr: 'Hrvatski',
  bg: 'български',
  sl: 'Slovenščina',
  et: 'Eesti',
  el: 'Ελληνικά',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  nl: 'Nederlandse',
  'nl-be': 'Nederlands (België)',
  da: 'Dansk',
  fi: 'Suomi',
  sv: 'Svenska',
  pt: 'Português',
  uk: 'Українська'
};
const countryCodeToCountryName = countryCode => {
  const displayNames = new Intl.DisplayNames([window.appState.lang], {
    type: 'region'
  });
  try {
    return displayNames.of(countryCode);
  } catch (e) {
    // In case when country code is not valid, return the country code itself
    return countryCode;
  }
};
const allCurrenciesName = {
  AUD: gettext('Australian dollar'),
  BGN: gettext('Bulgarian lev'),
  CAD: gettext('Canadian dollar'),
  CZK: gettext('Czech koruna'),
  DKK: gettext('Danish krone'),
  EUR: gettext('Euro'),
  GBP: gettext('British pound'),
  HRK: gettext('Croatian kuna'),
  HUF: gettext('Hungarian forint'),
  CHF: gettext('Swiss franc'),
  ILS: gettext('Israeli new shekel'),
  JPY: gettext('Japanese yen'),
  MXN: gettext('Mexican peso'),
  NOK: gettext('Norwegian krone'),
  PLN: gettext('Polish złoty'),
  RON: gettext('Romanian leu'),
  SEK: gettext('Swedish krona'),
  SGD: gettext('Singapore dollar'),
  THB: gettext('Thai baht'),
  UAH: gettext('Ukrainian hryvnia'),
  USD: gettext('United States dollar')
};
const allCurrenciesSymbol = {
  CZK: 'Kč',
  EUR: '€',
  PLN: 'zł',
  GBP: '£',
  RON: 'lei',
  HUF: 'Ft',
  UAH: '₴',
  CHF: 'Fr',
  USD: '$',
  HRK: 'kn',
  BGN: 'лв',
  AUD: '$',
  CAD: '$',
  DKK: 'kr',
  ILS: '₪',
  JPY: '¥',
  MXN: '$',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  NOK: 'kr'
};
const supportedLanguages = ['cs', 'hu', 'ro', 'en'];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  flags,
  historyItemTypes,
  notificationTypes
});

/***/ }),

/***/ 9432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W6: () => (/* binding */ useHistory),
/* harmony export */   m_: () => (/* binding */ useAsyncFunction)
/* harmony export */ });
/* unused harmony exports useAppStateLanguage, useCopyToClipboard */
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96540);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47767);



function useAsyncFunction(fn, callback) {
  const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  });
  const wrapper = async function () {
    setIsLoading(true);
    try {
      const result = await fn(...arguments);
      if (isMounted.current) {
        setIsLoading(false);
        if (callback) {
          callback();
        }
        return result;
      }
    } catch (error) {
      if (isMounted.current) {
        setIsLoading(false);
        throw error;
      }
    }
  };
  return [wrapper, isLoading];
}
function useAppStateLanguage(initial) {
  const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initial || window.appState.lang);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.appState.lang = lang;
  }, [lang]);
  return [lang, setLang];
}
function useHistory() {
  const navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useNavigate */ .Zp)();
  const location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .zy)();
  const [listeners, setListeners] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    listeners.forEach(func => func(location.pathname));
  }, [location.pathname]);
  const listen = func => {
    setListeners(old => [...old, func]);
    function unregisterCallback() {
      setListeners(old => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .toggleItem */ .g6)(old, func));
    }
    return unregisterCallback;
  };
  return {
    push: navigate,
    go: navigate,
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    listen,
    location
  };
}
function useCopyToClipboard() {
  const [openPopup, setOpenPopup] = useState(false);
  const copyToClipboard = text => () => {
    const textarea = document.createElement('textarea');
    textarea.innerText = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    setOpenPopup(true);
    setTimeout(() => setOpenPopup(false), 1000);
  };
  return {
    copyToClipboard,
    openCopiedPopup: openPopup
  };
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  useAsyncFunction,
  useAppStateLanguage
});

/***/ }),

/***/ 5367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10775);
/* harmony import */ var _CardContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98736);
/* harmony import */ var _CardFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66058);
/* harmony import */ var _CardHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5376);






function Card(_ref) {
  let {
    id,
    basic,
    children,
    loading = false,
    flat = false
  } = _ref;
  const classArray = ['relative', 'bg-white', 'rounded-lg'];
  if (flat) {
    classArray.push('border', 'border-gray-200');
  } else {
    classArray.push('shadow');
  }
  if (basic) {
    classArray.push('card-basic'); // custom class
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classArray.join(' '),
    id: id
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .e, {
    className: "absolute inset-0 z-20",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Card, {
  Content: _CardContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
  Header: _CardHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  Footer: _CardFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A
}));

/***/ }),

/***/ 45751:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _FeedEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31871);


function Feed(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "feed flow-root"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, children));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Feed, {
  Event: _FeedEvent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A
}));

/***/ }),

/***/ 10775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $n: () => (/* reexport */ button_Button/* default */.A),
  Zp: () => (/* reexport */ Card/* default */.A),
  Sc: () => (/* reexport */ Checkbox/* default */.A),
  Rr: () => (/* reexport */ Dimmer/* default */.A),
  cG: () => (/* reexport */ Divider/* default */.A),
  lV: () => (/* reexport */ Form/* default */.A),
  In: () => (/* reexport */ icon_Icon/* default */.Ay$),
  JU: () => (/* reexport */ Label/* default */.A),
  aH: () => (/* reexport */ Loader/* default */.A),
  QB: () => (/* reexport */ Message/* default */.A),
  hJ: () => (/* reexport */ Overlay/* default */.A),
  zD: () => (/* reexport */ Popup/* default */.A),
  ZL: () => (/* reexport */ Portal/* default */.A),
  Y4: () => (/* reexport */ Segment/* default */.A),
  N9: () => (/* reexport */ ToastContainer/* default */.A),
  oR: () => (/* reexport */ toast/* default */.A)
});

// UNUSED EXPORTS: ActionPanel, Breadcrumbs, Collapse, Confirm, Dropdown, Feed, FeedEvent, Input, Modal, Multiselect, NamedProperty, Pagination, ProgressBar, Radio, RadioPanel, Select, SlideOver, Statistic, Step, StepGroup, Table, Tabs, Textarea

// EXTERNAL MODULE: ./react/ui/action-panel/ActionPanel.tsx
var ActionPanel = __webpack_require__(50188);
// EXTERNAL MODULE: ./react/ui/breadcrumbs/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(45181);
// EXTERNAL MODULE: ./react/ui/button/Button.tsx
var button_Button = __webpack_require__(43787);
// EXTERNAL MODULE: ./react/ui/card/Card.tsx
var Card = __webpack_require__(5367);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/ui/confirm/Confirm.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function Confirm(_ref) {
  let {
    header = gettext('Confirm'),
    content = gettext('Are you sure?'),
    children,
    confirmButton = {},
    cancelButton = {
      children: gettext('Cancel')
    },
    negative = false,
    confirmDelete = false,
    onConfirm,
    onCancel,
    size
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm();
  };
  const handleCancel = () => {
    setIsOpen(false);
    if (onCancel) onCancel();
  };
  confirmButton.onClick = handleConfirm;
  cancelButton.onClick = handleCancel;
  if (negative) {
    confirmButton = _objectSpread({
      negative: true
    }, confirmButton);
  } else {
    confirmButton = _objectSpread({
      primary: true,
      children: gettext('Confirm')
    }, confirmButton);
  }
  if (confirmDelete) {
    confirmButton = _objectSpread({
      children: gettext('Delete')
    }, confirmButton);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, {
    onClick: e => {
      e.stopPropagation();
      setIsOpen(true);
    }
  }), /*#__PURE__*/React.createElement(Modal, {
    open: isOpen,
    onClose: handleCancel,
    size: size
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("div", {
    className: "sm:flex sm:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "exclamation",
    className: "h-6 w-6 text-red-600"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-medium leading-6 text-gray-900",
    id: "modal-headline"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-500"
  }, content))))), /*#__PURE__*/React.createElement(Modal.Footer, {
    gray: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end gap-3"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    classNames: classes => [...classes, 'sm:mt-0', 'sm:w-auto', 'sm:text-sm']
  }, cancelButton)), /*#__PURE__*/React.createElement(Button, _extends({
    classNames: classes => [...classes, 'sm:w-auto', 'sm:text-sm']
  }, confirmButton))))));
}
/* harmony default export */ const confirm_Confirm = ((/* unused pure expression or super */ null && (Confirm)));
// EXTERNAL MODULE: ./react/ui/dimmer/Dimmer.tsx
var Dimmer = __webpack_require__(81647);
// EXTERNAL MODULE: ./react/ui/divider/Divider.tsx
var Divider = __webpack_require__(81245);
// EXTERNAL MODULE: ./react/ui/dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(94557);
// EXTERNAL MODULE: ./react/ui/feed/Feed.tsx
var Feed = __webpack_require__(45751);
// EXTERNAL MODULE: ./react/ui/feed/FeedEvent.tsx
var FeedEvent = __webpack_require__(31871);
// EXTERNAL MODULE: ./react/ui/form/Form.tsx
var Form = __webpack_require__(14823);
// EXTERNAL MODULE: ./react/ui/form/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(95520);
// EXTERNAL MODULE: ./react/ui/icon/Icon.tsx + 454 modules
var icon_Icon = __webpack_require__(53623);
// EXTERNAL MODULE: ./react/ui/form/input/Input.tsx
var Input = __webpack_require__(31496);
// EXTERNAL MODULE: ./react/ui/label/Label.tsx
var Label = __webpack_require__(69817);
// EXTERNAL MODULE: ./react/ui/loader/Loader.tsx
var Loader = __webpack_require__(473);
// EXTERNAL MODULE: ./react/ui/message/Message.tsx
var Message = __webpack_require__(69349);
// EXTERNAL MODULE: ./react/ui/modal/Modal.tsx
var modal_Modal = __webpack_require__(95857);
// EXTERNAL MODULE: ./react/ui/form/multiselect/Multiselect.tsx + 1 modules
var Multiselect = __webpack_require__(4922);
;// ./react/ui/named-propery/NamedProperty.tsx

function NamedProperty(_ref) {
  let {
    name,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-sm font-medium text-gray-500"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-sm text-gray-900"
  }, value));
}
/* harmony default export */ const named_propery_NamedProperty = ((/* unused pure expression or super */ null && (NamedProperty)));
// EXTERNAL MODULE: ./react/ui/overlay/Overlay.tsx
var Overlay = __webpack_require__(65321);
// EXTERNAL MODULE: ./react/ui/pagination/Pagination.tsx
var Pagination = __webpack_require__(29635);
// EXTERNAL MODULE: ./react/ui/popup/Popup.tsx
var Popup = __webpack_require__(59005);
// EXTERNAL MODULE: ./react/ui/portal/Portal.tsx
var Portal = __webpack_require__(95971);
// EXTERNAL MODULE: ./react/ui/progressbar/ProgressBar.tsx
var ProgressBar = __webpack_require__(7777);
// EXTERNAL MODULE: ./react/ui/form/radio/Radio.tsx
var Radio = __webpack_require__(51304);
// EXTERNAL MODULE: ./react/ui/segment/Segment.tsx
var Segment = __webpack_require__(16369);
// EXTERNAL MODULE: ./react/ui/form/select/Select.tsx
var Select = __webpack_require__(44874);
// EXTERNAL MODULE: ./react/ui/slide-over/SlideOver.tsx
var SlideOver = __webpack_require__(33708);
// EXTERNAL MODULE: ./react/ui/statistic/Statistic.tsx
var Statistic = __webpack_require__(18973);
// EXTERNAL MODULE: ./react/ui/step/Step.tsx
var Step = __webpack_require__(747);
// EXTERNAL MODULE: ./react/ui/step/StepGroup.tsx
var StepGroup = __webpack_require__(17526);
// EXTERNAL MODULE: ./react/ui/table/Table.tsx
var Table = __webpack_require__(19873);
// EXTERNAL MODULE: ./react/ui/tabs/Tabs.tsx + 1 modules
var Tabs = __webpack_require__(46305);
// EXTERNAL MODULE: ./react/ui/form/textarea/Textarea.tsx
var Textarea = __webpack_require__(97670);
// EXTERNAL MODULE: ./react/ui/toast/index.ts
var toast = __webpack_require__(82468);
// EXTERNAL MODULE: ./react/ui/toast/ToastContainer.tsx + 1 modules
var ToastContainer = __webpack_require__(34161);
// EXTERNAL MODULE: ./react/ui/collapse/Collapse.tsx
var Collapse = __webpack_require__(84373);
// EXTERNAL MODULE: ./react/ui/form/radioPanel/RadioPanel.tsx
var RadioPanel = __webpack_require__(43320);
;// ./react/ui/index.ts









































/***/ }),

/***/ 69349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10775);


const getBackgroundColor = color => {
  switch (color) {
    case 'red':
      return 'bg-red-50';
    case 'yellow':
      return 'bg-yellow-50';
    case 'green':
      return 'bg-green-50';
    case 'blue':
      return 'bg-blue-50';
    default:
      return 'bg-blue-50';
  }
};
const getHeadingTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-800';
    case 'yellow':
      return 'text-yellow-800';
    case 'green':
      return 'text-green-800';
    case 'blue':
      return 'text-blue-800';
    default:
      return 'text-blue-800';
  }
};
const getTextColor = color => {
  switch (color) {
    case 'red':
      return 'text-red-700';
    case 'yellow':
      return 'text-yellow-700';
    case 'green':
      return 'text-green-700';
    case 'blue':
      return 'text-blue-700';
    default:
      return 'text-blue-700';
  }
};
const getBorderColor = color => {
  switch (color) {
    case 'red':
      return 'border-red-400';
    case 'yellow':
      return 'border-yellow-400';
    case 'green':
      return 'border-green-400';
    case 'blue':
      return 'border-blue-400';
    default:
      return 'border-blue-400';
  }
};
function Message(_ref) {
  let {
    error = false,
    warning = false,
    success = false,
    info = false,
    border = false,
    heading,
    children,
    displayIcon = true
  } = _ref;
  let color;
  let icon;
  const iconContainerClasses = ['flex-shrink-0'];
  const containerClasses = ['rounded-md', 'p-4'];
  const contentClasses = ['w-full'];
  const headingClasses = ['text-sm', 'font-medium', 'mb-2'];
  const childrenClasses = ['text-sm'];
  if (error) {
    color = 'red';
    icon = 'x-circle';
    iconContainerClasses.push('-mt-1');
  } else if (warning) {
    color = 'yellow';
    icon = 'exclamation';
    iconContainerClasses.push('-mt-0.5');
  } else if (success) {
    color = 'green';
    icon = 'check-circle';
    iconContainerClasses.push('-mt-1');
  } else {
    color = 'blue';
    icon = 'information-circle';
    iconContainerClasses.push('-mt-1');
  }
  containerClasses.push(getBackgroundColor(color));
  if (border) {
    containerClasses.push("border");
    containerClasses.push(getBorderColor(color));
  }
  headingClasses.push(getHeadingTextColor(color));
  childrenClasses.push(getTextColor(color));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: containerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex gap-1"
  }, displayIcon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: iconContainerClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: icon,
    color: color,
    fitted: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: contentClasses.join(' ')
  }, heading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", {
    className: headingClasses.join(' ')
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: childrenClasses.join(' ')
  }, children))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Message);

/***/ }),

/***/ 95857:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10775);
/* harmony import */ var ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(473);
/* harmony import */ var _ModalContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59910);
/* harmony import */ var _ModalFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81972);
/* harmony import */ var _ModalHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91446);







function getSizeClass(size) {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
}
const getMaxSizeClassName = size => {
  switch (size) {
    case 'sm':
      return 'max-w-sm';
    case 'md':
      return 'max-w-md';
    case 'lg':
      return 'max-w-lg';
    case 'xl':
      return 'max-w-xl';
    case '2xl':
      return 'max-w-2xl';
    case '3xl':
      return 'max-w-3xl';
    case '4xl':
      return 'max-w-4xl';
    case '5xl':
      return 'max-w-5xl';
    case '6xl':
      return 'max-w-6xl';
    case '7xl':
      return 'max-w-7xl';
    default:
      return 'max-w-lg';
  }
};
function Modal(_ref) {
  let {
    id,
    loading = false,
    size = 'lg',
    dismissible = false,
    open,
    onClose,
    children
  } = _ref;
  const keyListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleClose = () => {
    if (onClose) onClose();
  };
  const handleOverlayClick = () => {
    handleClose();
  };
  const listenToEscape = e => {
    if (e.keyCode === 27) {
      handleClose(); // close on escape
    }
  };
  const addListener = () => {
    if (!keyListener.current) {
      window.addEventListener('keydown', listenToEscape, false);
      keyListener.current = listenToEscape;
    }
  };
  const removeListener = () => {
    if (keyListener.current) {
      window.removeEventListener('keydown', keyListener.current, false);
      keyListener.current = null;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (open) {
      addListener();
    } else {
      removeListener();
    }
    return () => {
      removeListener();
    };
  }, [open]);
  const sizeClass = getSizeClass(size);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Overlay */ .hJ, {
    open: open,
    onOverlayClick: handleOverlayClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    id: id,
    show: open,
    className: "inline-block transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all my-8 align-middle ".concat(sizeClass, " w-full"),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "modal-headline",
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 translate-y-0 scale-95",
    enterTo: "opacity-100 translate-y-0 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 scale-100",
    leaveTo: "opacity-0 translate-y-4 translate-y-0 scale-95"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .e, {
    className: "absolute inset-0 z-50",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center bg-white opacity-70 rounded-lg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onClick: e => e.stopPropagation(),
    className: "contents"
  }, children), dismissible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute top-0 right-0 hidden pt-4 pr-4 block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    type: "button",
    className: "rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: () => handleClose()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "sr-only"
  }, gettext('Close')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: "x",
    className: "h-6 w-6",
    "aria-hidden": "true"
  })))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Modal, {
  Header: _ModalHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
  Content: _ModalContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Footer: _ModalFooter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A
}));

/***/ }),

/***/ 7777:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function getOpacityFromProgress(progress) {
  if (progress <= 10) {
    return 'opacity-25';
  }
  if (progress > 10 && progress < 20) {
    return 'opacity-30';
  }
  if (progress > 20 && progress < 30) {
    return 'opacity-40';
  }
  if (progress >= 30 && progress < 40) {
    return 'opacity-50';
  }
  if (progress >= 40 && progress < 50) {
    return 'opacity-60';
  }
  if (progress >= 50 && progress < 60) {
    return 'opacity-70';
  }
  if (progress >= 60 && progress < 70) {
    return 'opacity-80';
  }
  if (progress >= 70 && progress < 80) {
    return 'opacity-90';
  }
  if (progress >= 80 && progress < 90) {
    return 'opacity-95';
  }
  return 'opacity-100';
}
function getColorFromProgress(progress, failed, gradient) {
  if (failed) {
    return ['bg-red-600'];
  }
  switch (progress) {
    case 100:
      return ['bg-green-500'];
    default:
      return ['bg-primary-600', gradient ? getOpacityFromProgress(progress) : ''];
  }
}
function ProgressBar(_ref) {
  let {
    progress = 10,
    failed = false,
    done = false,
    gradient = true,
    getColor = getColorFromProgress
  } = _ref;
  progress = Math.max(progress, 10);
  if (done || failed) {
    progress = 100;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "h-2 w-full space-y-3 rounded-full bg-gray-200"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "".concat(progress, "%"),
      transition: 'width 0.3s ease-in-out'
    },
    className: classNames(['h-full', 'rounded-full', ...getColor(progress, failed, gradient)])
  }));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ProgressBar)));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			248: 0,
/******/ 			541: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkretino"] = self["webpackChunkretino"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, [311,15,670,400,767,588,591,911,541,256,779,538], () => (__webpack_require__(27461)))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [311,15,670,400,767,588,591,911,541,256,779,538], () => (__webpack_require__(13028)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;